// Generated by scripts/generate-pricing-registry.mts. Do not edit manually.
// Source reconciliation date: 2026-10-08.

export const GENERATED_API_PRODUCTS = [
  {
    "skuId": "sku_api_medical_drug_interaction_check_api_2026",
    "businessId": "medical",
    "sourceBusinessId": "medical",
    "businessName": "Anchor Medical",
    "name": "Drug Interaction Check API",
    "description": "Real-time drug-drug and drug-gene interaction analysis across 35M+ literature records",
    "endpointPath": "/api/v1/drug-interactions",
    "unitAmountMinor": 15
  },
  {
    "skuId": "sku_api_medical_adverse_event_signal_api_2026",
    "businessId": "medical",
    "sourceBusinessId": "medical",
    "businessName": "Anchor Medical",
    "name": "Adverse Event Signal API",
    "description": "Query adverse event signals from FAERS and global pharmacovigilance databases",
    "endpointPath": "/api/v1/adverse-events",
    "unitAmountMinor": 25
  },
  {
    "skuId": "sku_api_medical_literature_synthesis_api_2026",
    "businessId": "medical",
    "sourceBusinessId": "medical",
    "businessName": "Anchor Medical",
    "name": "Literature Synthesis API",
    "description": "AI-powered synthesis of research papers on any biomedical topic",
    "endpointPath": "/api/v1/literature-synthesis",
    "unitAmountMinor": 50
  },
  {
    "skuId": "sku_api_medical_clinical_trial_intelligence_api_2026",
    "businessId": "medical",
    "sourceBusinessId": "medical",
    "businessName": "Anchor Medical",
    "name": "Clinical Trial Intelligence API",
    "description": "Real-time trial status, enrollment data, and competitive landscape queries",
    "endpointPath": "/api/v1/clinical-trials",
    "unitAmountMinor": 10
  },
  {
    "skuId": "sku_api_finance_market_anomaly_detection_api_2026",
    "businessId": "finance",
    "sourceBusinessId": "finance",
    "businessName": "Anchor Finance",
    "name": "Market Anomaly Detection API",
    "description": "Real-time anomaly detection across 50+ global exchanges with confidence scoring",
    "endpointPath": "/api/v1/market-anomalies",
    "unitAmountMinor": 50
  },
  {
    "skuId": "sku_api_finance_regulatory_filing_extract_api_2026",
    "businessId": "finance",
    "sourceBusinessId": "finance",
    "businessName": "Anchor Finance",
    "name": "Regulatory Filing Extract API",
    "description": "Structured data extraction from SEC, FCA, and global regulatory filings",
    "endpointPath": "/api/v1/filing-analysis",
    "unitAmountMinor": 100
  },
  {
    "skuId": "sku_api_finance_cross_asset_correlation_api_2026",
    "businessId": "finance",
    "sourceBusinessId": "finance",
    "businessName": "Anchor Finance",
    "name": "Cross-Asset Correlation API",
    "description": "Query hidden correlations between any combination of asset classes and indicators",
    "endpointPath": "/api/v1/correlations",
    "unitAmountMinor": 75
  },
  {
    "skuId": "sku_api_finance_predictive_signal_api_2026",
    "businessId": "finance",
    "sourceBusinessId": "finance",
    "businessName": "Anchor Finance",
    "name": "Predictive Signal API",
    "description": "AI-generated alpha signals with direction, magnitude, and confidence scoring",
    "endpointPath": "/api/v1/signals",
    "unitAmountMinor": 200
  },
  {
    "skuId": "sku_api_legal_regulatory_change_api_2026",
    "businessId": "legal",
    "sourceBusinessId": "legal",
    "businessName": "Anchor Legal",
    "name": "Regulatory Change API",
    "description": "Real-time regulatory change monitoring across 190+ jurisdictions with impact scoring",
    "endpointPath": "/api/v1/regulatory-changes",
    "unitAmountMinor": 30
  },
  {
    "skuId": "sku_api_legal_contract_risk_analysis_api_2026",
    "businessId": "legal",
    "sourceBusinessId": "legal",
    "businessName": "Anchor Legal",
    "name": "Contract Risk Analysis API",
    "description": "AI-powered contract review returning risk scores, flagged clauses, and recommendations",
    "endpointPath": "/api/v1/contract-analysis",
    "unitAmountMinor": 200
  },
  {
    "skuId": "sku_api_legal_case_law_search_api_2026",
    "businessId": "legal",
    "sourceBusinessId": "legal",
    "businessName": "Anchor Legal",
    "name": "Case Law Search API",
    "description": "Semantic search across global case law with precedent mapping and outcome prediction",
    "endpointPath": "/api/v1/case-law",
    "unitAmountMinor": 50
  },
  {
    "skuId": "sku_api_legal_compliance_gap_api_2026",
    "businessId": "legal",
    "sourceBusinessId": "legal",
    "businessName": "Anchor Legal",
    "name": "Compliance Gap API",
    "description": "Compare your compliance posture against regulatory requirements across jurisdictions",
    "endpointPath": "/api/v1/compliance-gap",
    "unitAmountMinor": 100
  },
  {
    "skuId": "sku_api_climate_physical_risk_score_api_2026",
    "businessId": "climate",
    "sourceBusinessId": "climate",
    "businessName": "Anchor Climate",
    "name": "Physical Risk Score API",
    "description": "Asset-level physical climate risk scoring for flood, fire, storm, and sea-level rise",
    "endpointPath": "/api/v1/physical-risk",
    "unitAmountMinor": 40
  },
  {
    "skuId": "sku_api_climate_carbon_footprint_api_2026",
    "businessId": "climate",
    "sourceBusinessId": "climate",
    "businessName": "Anchor Climate",
    "name": "Carbon Footprint API",
    "description": "Automated Scope 1/2/3 emissions calculation for organisations and supply chains",
    "endpointPath": "/api/v1/carbon-footprint",
    "unitAmountMinor": 60
  },
  {
    "skuId": "sku_api_climate_climate_forecast_api_2026",
    "businessId": "climate",
    "sourceBusinessId": "climate",
    "businessName": "Anchor Climate",
    "name": "Climate Forecast API",
    "description": "Hyper-local climate forecasting with seasonal and decadal projections",
    "endpointPath": "/api/v1/climate-forecast",
    "unitAmountMinor": 35
  },
  {
    "skuId": "sku_api_climate_esg_score_api_2026",
    "businessId": "climate",
    "sourceBusinessId": "climate",
    "businessName": "Anchor Climate",
    "name": "ESG Score API",
    "description": "Comprehensive ESG scoring for companies, portfolios, and sovereign entities",
    "endpointPath": "/api/v1/esg-score",
    "unitAmountMinor": 50
  },
  {
    "skuId": "sku_api_defence_threat_assessment_api_2026",
    "businessId": "defence",
    "sourceBusinessId": "defence",
    "businessName": "Anchor Defence",
    "name": "Threat Assessment API",
    "description": "Multi-domain threat scoring for regions, actors, and scenarios with confidence levels",
    "endpointPath": "/api/v1/threat-assessment",
    "unitAmountMinor": 500
  },
  {
    "skuId": "sku_api_defence_adversary_profile_api_2026",
    "businessId": "defence",
    "sourceBusinessId": "defence",
    "businessName": "Anchor Defence",
    "name": "Adversary Profile API",
    "description": "Detailed threat actor profiles with TTPs, capabilities, and predicted operations",
    "endpointPath": "/api/v1/adversary-profile",
    "unitAmountMinor": 1000
  },
  {
    "skuId": "sku_api_defence_geopolitical_risk_api_2026",
    "businessId": "defence",
    "sourceBusinessId": "defence",
    "businessName": "Anchor Defence",
    "name": "Geopolitical Risk API",
    "description": "Real-time geopolitical risk scores for 195 nations with trend analysis",
    "endpointPath": "/api/v1/geopolitical-risk",
    "unitAmountMinor": 200
  },
  {
    "skuId": "sku_api_defence_osint_aggregation_api_2026",
    "businessId": "defence",
    "sourceBusinessId": "defence",
    "businessName": "Anchor Defence",
    "name": "OSINT Aggregation API",
    "description": "Curated open-source intelligence feeds with AI-powered relevance scoring",
    "endpointPath": "/api/v1/osint",
    "unitAmountMinor": 100
  },
  {
    "skuId": "sku_api_defence_conflict_zone_feed_api_2026",
    "businessId": "defence",
    "sourceBusinessId": "defence",
    "businessName": "Anchor Defence",
    "name": "Conflict Zone Feed API",
    "description": "Real-time conflict zone status, sensor detections, and threat levels for 10 active theatres",
    "endpointPath": "/api/v1/conflict-zones",
    "unitAmountMinor": 800
  },
  {
    "skuId": "sku_api_defence_comms_link_health_api_2026",
    "businessId": "defence",
    "sourceBusinessId": "defence",
    "businessName": "Anchor Defence",
    "name": "Comms Link Health API",
    "description": "Link 16, BACN, and SATCOM health per conflict zone with EW jamming alerts",
    "endpointPath": "/api/v1/comms-health",
    "unitAmountMinor": 1200
  },
  {
    "skuId": "sku_api_defence_aukus_data_flow_api_2026",
    "businessId": "defence",
    "sourceBusinessId": "defence",
    "businessName": "Anchor Defence",
    "name": "AUKUS Data Flow API",
    "description": "Three-nation interoperability status — E-11A relay, RAAF sync, Electronic Noise Floor",
    "endpointPath": "/api/v1/aukus-dataflow",
    "unitAmountMinor": 1500
  },
  {
    "skuId": "sku_api_defence_sensor_to_shooter_api_2026",
    "businessId": "defence",
    "sourceBusinessId": "defence",
    "businessName": "Anchor Defence",
    "name": "Sensor-to-Shooter API",
    "description": "Kill chain latency and hop-by-hop status from F-35A MADL to ground commander",
    "endpointPath": "/api/v1/sensor-to-shooter",
    "unitAmountMinor": 2000
  },
  {
    "skuId": "sku_api_energy_grid_status_api_2026",
    "businessId": "energy",
    "sourceBusinessId": "energy",
    "businessName": "Anchor Energy",
    "name": "Grid Status API",
    "description": "Real-time grid load, frequency, and stability data for regional and national grids",
    "endpointPath": "/api/v1/grid-status",
    "unitAmountMinor": 20
  },
  {
    "skuId": "sku_api_energy_energy_price_forecast_api_2026",
    "businessId": "energy",
    "sourceBusinessId": "energy",
    "businessName": "Anchor Energy",
    "name": "Energy Price Forecast API",
    "description": "AI-powered commodity price forecasting for oil, gas, LNG, and electricity markets",
    "endpointPath": "/api/v1/energy-forecast",
    "unitAmountMinor": 75
  },
  {
    "skuId": "sku_api_energy_supply_disruption_alert_api_2026",
    "businessId": "energy",
    "sourceBusinessId": "energy",
    "businessName": "Anchor Energy",
    "name": "Supply Disruption Alert API",
    "description": "Real-time energy supply disruption alerts with severity scoring and impact prediction",
    "endpointPath": "/api/v1/supply-disruptions",
    "unitAmountMinor": 50
  },
  {
    "skuId": "sku_api_energy_carbon_market_api_2026",
    "businessId": "energy",
    "sourceBusinessId": "energy",
    "businessName": "Anchor Energy",
    "name": "Carbon Market API",
    "description": "Carbon credit pricing, ETS data, and emissions compliance intelligence",
    "endpointPath": "/api/v1/carbon-market",
    "unitAmountMinor": 35
  },
  {
    "skuId": "sku_api_maritime_vessel_tracking_api_2026",
    "businessId": "maritime",
    "sourceBusinessId": "maritime",
    "businessName": "Anchor Maritime",
    "name": "Vessel Tracking API",
    "description": "Real-time AIS position, course, and speed for 150K+ vessels with anomaly scoring",
    "endpointPath": "/api/v1/vessel-tracking",
    "unitAmountMinor": 15
  },
  {
    "skuId": "sku_api_maritime_port_congestion_api_2026",
    "businessId": "maritime",
    "sourceBusinessId": "maritime",
    "businessName": "Anchor Maritime",
    "name": "Port Congestion API",
    "description": "Real-time port congestion levels, turnaround times, and predicted wait times",
    "endpointPath": "/api/v1/port-congestion",
    "unitAmountMinor": 25
  },
  {
    "skuId": "sku_api_maritime_sanctions_screening_api_2026",
    "businessId": "maritime",
    "sourceBusinessId": "maritime",
    "businessName": "Anchor Maritime",
    "name": "Sanctions Screening API",
    "description": "Vessel and entity sanctions screening against global sanctions lists",
    "endpointPath": "/api/v1/sanctions-screen",
    "unitAmountMinor": 50
  },
  {
    "skuId": "sku_api_maritime_maritime_risk_api_2026",
    "businessId": "maritime",
    "sourceBusinessId": "maritime",
    "businessName": "Anchor Maritime",
    "name": "Maritime Risk API",
    "description": "Route-level maritime risk scoring for piracy, weather, and geopolitical threats",
    "endpointPath": "/api/v1/maritime-risk",
    "unitAmountMinor": 40
  },
  {
    "skuId": "sku_api_space_orbital_tracking_api_2026",
    "businessId": "space",
    "sourceBusinessId": "space",
    "businessName": "Anchor Space",
    "name": "Orbital Tracking API",
    "description": "Real-time position, velocity, and orbital elements for 40K+ tracked objects",
    "endpointPath": "/api/v1/orbital-tracking",
    "unitAmountMinor": 30
  },
  {
    "skuId": "sku_api_space_conjunction_analysis_api_2026",
    "businessId": "space",
    "sourceBusinessId": "space",
    "businessName": "Anchor Space",
    "name": "Conjunction Analysis API",
    "description": "Collision probability assessment for specified satellite against all tracked objects",
    "endpointPath": "/api/v1/conjunction",
    "unitAmountMinor": 500
  },
  {
    "skuId": "sku_api_space_debris_forecast_api_2026",
    "businessId": "space",
    "sourceBusinessId": "space",
    "businessName": "Anchor Space",
    "name": "Debris Forecast API",
    "description": "Long-term orbital debris propagation and cascade risk forecasting",
    "endpointPath": "/api/v1/debris-forecast",
    "unitAmountMinor": 200
  },
  {
    "skuId": "sku_api_space_launch_intelligence_api_2026",
    "businessId": "space",
    "sourceBusinessId": "space",
    "businessName": "Anchor Space",
    "name": "Launch Intelligence API",
    "description": "Global launch schedule, trajectory analysis, and orbital injection data",
    "endpointPath": "/api/v1/launch-intel",
    "unitAmountMinor": 100
  },
  {
    "skuId": "sku_api_agriculture_crop_health_api_2026",
    "businessId": "agriculture",
    "sourceBusinessId": "agriculture",
    "businessName": "Anchor Agriculture",
    "name": "Crop Health API",
    "description": "Field-level crop health scoring from satellite imagery with NDVI, moisture, and nutrient analysis",
    "endpointPath": "/api/v1/crop-health",
    "unitAmountMinor": 20
  },
  {
    "skuId": "sku_api_agriculture_pest_prediction_api_2026",
    "businessId": "agriculture",
    "sourceBusinessId": "agriculture",
    "businessName": "Anchor Agriculture",
    "name": "Pest Prediction API",
    "description": "AI-powered pest migration and disease spread forecasting for specified regions",
    "endpointPath": "/api/v1/pest-prediction",
    "unitAmountMinor": 35
  },
  {
    "skuId": "sku_api_agriculture_commodity_forecast_api_2026",
    "businessId": "agriculture",
    "sourceBusinessId": "agriculture",
    "businessName": "Anchor Agriculture",
    "name": "Commodity Forecast API",
    "description": "Agricultural commodity price forecasting with weather and supply chain impact analysis",
    "endpointPath": "/api/v1/agri-commodity",
    "unitAmountMinor": 50
  },
  {
    "skuId": "sku_api_agriculture_yield_estimation_api_2026",
    "businessId": "agriculture",
    "sourceBusinessId": "agriculture",
    "businessName": "Anchor Agriculture",
    "name": "Yield Estimation API",
    "description": "AI-powered crop yield estimation combining satellite, weather, and historical data",
    "endpointPath": "/api/v1/yield-estimate",
    "unitAmountMinor": 40
  },
  {
    "skuId": "sku_api_education_skills_gap_api_2026",
    "businessId": "education",
    "sourceBusinessId": "education",
    "businessName": "Anchor Education",
    "name": "Skills Gap API",
    "description": "Real-time skills gap analysis between education output and industry demand for any region/sector",
    "endpointPath": "/api/v1/skills-gap",
    "unitAmountMinor": 25
  },
  {
    "skuId": "sku_api_education_curriculum_alignment_api_2026",
    "businessId": "education",
    "sourceBusinessId": "education",
    "businessName": "Anchor Education",
    "name": "Curriculum Alignment API",
    "description": "Score curriculum content against live industry skill requirements with gap recommendations",
    "endpointPath": "/api/v1/curriculum-alignment",
    "unitAmountMinor": 40
  },
  {
    "skuId": "sku_api_education_student_risk_api_2026",
    "businessId": "education",
    "sourceBusinessId": "education",
    "businessName": "Anchor Education",
    "name": "Student Risk API",
    "description": "AI-powered at-risk student prediction from engagement and assessment data",
    "endpointPath": "/api/v1/student-risk",
    "unitAmountMinor": 15
  },
  {
    "skuId": "sku_api_education_labour_market_signal_api_2026",
    "businessId": "education",
    "sourceBusinessId": "education",
    "businessName": "Anchor Education",
    "name": "Labour Market Signal API",
    "description": "Real-time labour market demand signals for skills, roles, and qualifications",
    "endpointPath": "/api/v1/labour-market",
    "unitAmountMinor": 30
  },
  {
    "skuId": "sku_api_leo_criminal_intelligence_api_2026",
    "businessId": "leo",
    "sourceBusinessId": "leo",
    "businessName": "Anchor LEO",
    "name": "Criminal Intelligence API",
    "description": "Query criminal records, arrest warrants, and case intelligence across integrated jurisdictions",
    "endpointPath": "/api/v1/criminal-intelligence",
    "unitAmountMinor": 75
  },
  {
    "skuId": "sku_api_leo_cryptocurrency_trace_api_2026",
    "businessId": "leo",
    "sourceBusinessId": "leo",
    "businessName": "Anchor LEO",
    "name": "Cryptocurrency Trace API",
    "description": "Trace cryptocurrency transactions through blockchain, mixers, and exchanges",
    "endpointPath": "/api/v1/crypto-trace",
    "unitAmountMinor": 150
  },
  {
    "skuId": "sku_api_leo_evidence_verification_api_2026",
    "businessId": "leo",
    "sourceBusinessId": "leo",
    "businessName": "Anchor LEO",
    "name": "Evidence Verification API",
    "description": "Verify evidence chain integrity and court admissibility status",
    "endpointPath": "/api/v1/evidence-verify",
    "unitAmountMinor": 50
  },
  {
    "skuId": "sku_api_leo_jurisdiction_compliance_api_2026",
    "businessId": "leo",
    "sourceBusinessId": "leo",
    "businessName": "Anchor LEO",
    "name": "Jurisdiction Compliance API",
    "description": "Check legal compliance requirements for evidence sharing between specific jurisdictions",
    "endpointPath": "/api/v1/jurisdiction-compliance",
    "unitAmountMinor": 25
  },
  {
    "skuId": "sku_api_wildlife_poaching_alert_api_2026",
    "businessId": "wildlife",
    "sourceBusinessId": "wildlife",
    "businessName": "Anchor Wildlife",
    "name": "Poaching Alert API",
    "description": "Real-time threat detection alerts with GPS coordinates, threat classification, and confidence scoring",
    "endpointPath": "/api/v1/poaching-alerts",
    "unitAmountMinor": 50
  },
  {
    "skuId": "sku_api_wildlife_species_tracking_api_2026",
    "businessId": "wildlife",
    "sourceBusinessId": "wildlife",
    "businessName": "Anchor Wildlife",
    "name": "Species Tracking API",
    "description": "GPS collar data, population analytics, and migration pattern queries",
    "endpointPath": "/api/v1/species-tracking",
    "unitAmountMinor": 25
  },
  {
    "skuId": "sku_api_wildlife_trafficking_intelligence_api_2026",
    "businessId": "wildlife",
    "sourceBusinessId": "wildlife",
    "businessName": "Anchor Wildlife",
    "name": "Trafficking Intelligence API",
    "description": "Dark web listing monitoring, cryptocurrency wallet tracing, and network analysis",
    "endpointPath": "/api/v1/trafficking-intel",
    "unitAmountMinor": 100
  },
  {
    "skuId": "sku_api_wildlife_satellite_analysis_api_2026",
    "businessId": "wildlife",
    "sourceBusinessId": "wildlife",
    "businessName": "Anchor Wildlife",
    "name": "Satellite Analysis API",
    "description": "Deforestation alerts, habitat change detection, and illegal activity identification",
    "endpointPath": "/api/v1/satellite-analysis",
    "unitAmountMinor": 75
  },
  {
    "skuId": "sku_api_casino_fraud_detection_api_2026",
    "businessId": "casino",
    "sourceBusinessId": "casino",
    "businessName": "Anchor Casino",
    "name": "Fraud Detection API",
    "description": "Real-time gaming fraud scoring, chip anomaly detection, and collusion analysis",
    "endpointPath": "/api/v1/casino-fraud",
    "unitAmountMinor": 75
  },
  {
    "skuId": "sku_api_casino_aml_intelligence_api_2026",
    "businessId": "casino",
    "sourceBusinessId": "casino",
    "businessName": "Anchor Casino",
    "name": "AML Intelligence API",
    "description": "Transaction risk scoring, suspicious activity detection, and regulatory compliance checks",
    "endpointPath": "/api/v1/casino-aml",
    "unitAmountMinor": 100
  },
  {
    "skuId": "sku_api_casino_surveillance_analytics_api_2026",
    "businessId": "casino",
    "sourceBusinessId": "casino",
    "businessName": "Anchor Casino",
    "name": "Surveillance Analytics API",
    "description": "Camera feed analysis, facial matching, and behaviour anomaly detection",
    "endpointPath": "/api/v1/casino-surveillance",
    "unitAmountMinor": 50
  },
  {
    "skuId": "sku_api_casino_guest_safety_api_2026",
    "businessId": "casino",
    "sourceBusinessId": "casino",
    "businessName": "Anchor Casino",
    "name": "Guest Safety API",
    "description": "Vulnerable person scoring, problem gambling indicators, and welfare alert triggers",
    "endpointPath": "/api/v1/casino-safety",
    "unitAmountMinor": 60
  },
  {
    "skuId": "sku_api_interpol_fugitive_intelligence_api_2026",
    "businessId": "interpol",
    "sourceBusinessId": "interpol",
    "businessName": "Anchor Interpol",
    "name": "Fugitive Intelligence API",
    "description": "Real-time fugitive tracking, movement prediction, and identity correlation across 194 nations",
    "endpointPath": "/api/v1/interpol-fugitive",
    "unitAmountMinor": 250
  },
  {
    "skuId": "sku_api_interpol_cybercrime_intelligence_api_2026",
    "businessId": "interpol",
    "sourceBusinessId": "interpol",
    "businessName": "Anchor Interpol",
    "name": "Cybercrime Intelligence API",
    "description": "Dark web monitoring, ransomware tracking, and coordinated takedown intelligence",
    "endpointPath": "/api/v1/interpol-cyber",
    "unitAmountMinor": 150
  },
  {
    "skuId": "sku_api_interpol_counter_terrorism_api_2026",
    "businessId": "interpol",
    "sourceBusinessId": "interpol",
    "businessName": "Anchor Interpol",
    "name": "Counter-Terrorism API",
    "description": "Threat actor tracking, network analysis, and cross-border alert distribution",
    "endpointPath": "/api/v1/interpol-ct",
    "unitAmountMinor": 300
  },
  {
    "skuId": "sku_api_interpol_trafficking_intelligence_api_2026",
    "businessId": "interpol",
    "sourceBusinessId": "interpol",
    "businessName": "Anchor Interpol",
    "name": "Trafficking Intelligence API",
    "description": "Route prediction, victim identification, financial network exposure, and rescue coordination",
    "endpointPath": "/api/v1/interpol-trafficking",
    "unitAmountMinor": 200
  },
  {
    "skuId": "sku_api_aviation_flight_safety_score_api_2026",
    "businessId": "aviation",
    "sourceBusinessId": "aviation",
    "businessName": "Anchor Aviation",
    "name": "Flight Safety Score API",
    "description": "Real-time safety scoring for individual flights based on telemetry, weather, and historical data",
    "endpointPath": "/api/v1/flight-safety",
    "unitAmountMinor": 20
  },
  {
    "skuId": "sku_api_aviation_predictive_maintenance_api_2026",
    "businessId": "aviation",
    "sourceBusinessId": "aviation",
    "businessName": "Anchor Aviation",
    "name": "Predictive Maintenance API",
    "description": "Component failure probability assessment from maintenance and sensor data",
    "endpointPath": "/api/v1/maintenance-predict",
    "unitAmountMinor": 35
  },
  {
    "skuId": "sku_api_aviation_airspace_threat_api_2026",
    "businessId": "aviation",
    "sourceBusinessId": "aviation",
    "businessName": "Anchor Aviation",
    "name": "Airspace Threat API",
    "description": "Real-time airspace threat detection and drone incursion alerts",
    "endpointPath": "/api/v1/airspace-threats",
    "unitAmountMinor": 30
  },
  {
    "skuId": "sku_api_aviation_route_optimisation_api_2026",
    "businessId": "aviation",
    "sourceBusinessId": "aviation",
    "businessName": "Anchor Aviation",
    "name": "Route Optimisation API",
    "description": "AI-optimised routing considering weather, traffic, and fuel efficiency",
    "endpointPath": "/api/v1/route-optimise",
    "unitAmountMinor": 25
  },
  {
    "skuId": "sku_api_charity_fund_trace_api_2026",
    "businessId": "charity",
    "sourceBusinessId": "charity",
    "businessName": "Anchor Charity",
    "name": "Fund Trace API",
    "description": "Track individual donations from source to beneficiary with full audit trail",
    "endpointPath": "/api/v1/fund-trace",
    "unitAmountMinor": 10
  },
  {
    "skuId": "sku_api_charity_fraud_detection_api_2026",
    "businessId": "charity",
    "sourceBusinessId": "charity",
    "businessName": "Anchor Charity",
    "name": "Fraud Detection API",
    "description": "Real-time fraud risk scoring for charity transactions and disbursements",
    "endpointPath": "/api/v1/charity-fraud",
    "unitAmountMinor": 20
  },
  {
    "skuId": "sku_api_charity_impact_score_api_2026",
    "businessId": "charity",
    "sourceBusinessId": "charity",
    "businessName": "Anchor Charity",
    "name": "Impact Score API",
    "description": "Programme impact verification and outcome measurement",
    "endpointPath": "/api/v1/impact-score",
    "unitAmountMinor": 15
  },
  {
    "skuId": "sku_api_charity_needs_assessment_api_2026",
    "businessId": "charity",
    "sourceBusinessId": "charity",
    "businessName": "Anchor Charity",
    "name": "Needs Assessment API",
    "description": "AI-powered humanitarian needs assessment for target populations",
    "endpointPath": "/api/v1/needs-assess",
    "unitAmountMinor": 25
  },
  {
    "skuId": "sku_api_crypto_transaction_trace_api_2026",
    "businessId": "crypto",
    "sourceBusinessId": "crypto",
    "businessName": "Anchor Crypto",
    "name": "Transaction Trace API",
    "description": "Trace any transaction across 50+ chains with full hop-by-hop analysis",
    "endpointPath": "/api/v1/tx-trace",
    "unitAmountMinor": 30
  },
  {
    "skuId": "sku_api_crypto_wallet_risk_score_api_2026",
    "businessId": "crypto",
    "sourceBusinessId": "crypto",
    "businessName": "Anchor Crypto",
    "name": "Wallet Risk Score API",
    "description": "Real-time risk scoring for any wallet address across all supported chains",
    "endpointPath": "/api/v1/wallet-risk",
    "unitAmountMinor": 15
  },
  {
    "skuId": "sku_api_crypto_aml_screen_api_2026",
    "businessId": "crypto",
    "sourceBusinessId": "crypto",
    "businessName": "Anchor Crypto",
    "name": "AML Screen API",
    "description": "Screen addresses against sanctions, PEP, and known illicit wallet databases",
    "endpointPath": "/api/v1/aml-screen",
    "unitAmountMinor": 10
  },
  {
    "skuId": "sku_api_crypto_rug_pull_prediction_api_2026",
    "businessId": "crypto",
    "sourceBusinessId": "crypto",
    "businessName": "Anchor Crypto",
    "name": "Rug Pull Prediction API",
    "description": "Probability scoring for rug pull risk on DeFi tokens and protocols",
    "endpointPath": "/api/v1/rugpull-predict",
    "unitAmountMinor": 50
  },
  {
    "skuId": "sku_api_entertainment_content_prediction_api_2026",
    "businessId": "entertainment",
    "sourceBusinessId": "entertainment",
    "businessName": "Anchor Entertainment",
    "name": "Content Prediction API",
    "description": "Predict audience reception and revenue potential for any content concept",
    "endpointPath": "/api/v1/content-predict",
    "unitAmountMinor": 40
  },
  {
    "skuId": "sku_api_entertainment_piracy_detection_api_2026",
    "businessId": "entertainment",
    "sourceBusinessId": "entertainment",
    "businessName": "Anchor Entertainment",
    "name": "Piracy Detection API",
    "description": "Search for pirated content across torrent, streaming, and social platforms",
    "endpointPath": "/api/v1/piracy-detect",
    "unitAmountMinor": 20
  },
  {
    "skuId": "sku_api_entertainment_audience_sentiment_api_2026",
    "businessId": "entertainment",
    "sourceBusinessId": "entertainment",
    "businessName": "Anchor Entertainment",
    "name": "Audience Sentiment API",
    "description": "Real-time audience sentiment analysis for content, artists, and events",
    "endpointPath": "/api/v1/audience-sentiment",
    "unitAmountMinor": 15
  },
  {
    "skuId": "sku_api_entertainment_trend_prediction_api_2026",
    "businessId": "entertainment",
    "sourceBusinessId": "entertainment",
    "businessName": "Anchor Entertainment",
    "name": "Trend Prediction API",
    "description": "Predict emerging entertainment trends across music, film, gaming, and live events",
    "endpointPath": "/api/v1/trend-predict",
    "unitAmountMinor": 30
  },
  {
    "skuId": "sku_api_mining_deposit_prediction_api_2026",
    "businessId": "mining",
    "sourceBusinessId": "mining",
    "businessName": "Anchor Mining",
    "name": "Deposit Prediction API",
    "description": "AI-driven mineral deposit probability scoring for exploration targets",
    "endpointPath": "/api/v1/deposit-predict",
    "unitAmountMinor": 100
  },
  {
    "skuId": "sku_api_mining_mine_safety_api_2026",
    "businessId": "mining",
    "sourceBusinessId": "mining",
    "businessName": "Anchor Mining",
    "name": "Mine Safety API",
    "description": "Real-time safety risk scoring and hazard prediction for mine operations",
    "endpointPath": "/api/v1/mine-safety",
    "unitAmountMinor": 25
  },
  {
    "skuId": "sku_api_mining_environmental_monitor_api_2026",
    "businessId": "mining",
    "sourceBusinessId": "mining",
    "businessName": "Anchor Mining",
    "name": "Environmental Monitor API",
    "description": "Satellite-based environmental compliance assessment for mine sites",
    "endpointPath": "/api/v1/mine-environment",
    "unitAmountMinor": 35
  },
  {
    "skuId": "sku_api_mining_ore_grade_api_2026",
    "businessId": "mining",
    "sourceBusinessId": "mining",
    "businessName": "Anchor Mining",
    "name": "Ore Grade API",
    "description": "Real-time ore grade estimation and production optimisation recommendations",
    "endpointPath": "/api/v1/ore-grade",
    "unitAmountMinor": 20
  },
  {
    "skuId": "sku_api_resources_water_monitor_api_2026",
    "businessId": "resources",
    "sourceBusinessId": "resources",
    "businessName": "Anchor Resources",
    "name": "Water Monitor API",
    "description": "Real-time water table levels, allocation tracking, and illegal extraction detection",
    "endpointPath": "/api/v1/water-monitor",
    "unitAmountMinor": 20
  },
  {
    "skuId": "sku_api_resources_deforestation_api_2026",
    "businessId": "resources",
    "sourceBusinessId": "resources",
    "businessName": "Anchor Resources",
    "name": "Deforestation API",
    "description": "Satellite-based forest clearing detection and change analysis",
    "endpointPath": "/api/v1/deforestation",
    "unitAmountMinor": 30
  },
  {
    "skuId": "sku_api_resources_heritage_site_api_2026",
    "businessId": "resources",
    "sourceBusinessId": "resources",
    "businessName": "Anchor Resources",
    "name": "Heritage Site API",
    "description": "Cultural heritage site proximity alerts and disturbance detection",
    "endpointPath": "/api/v1/heritage-monitor",
    "unitAmountMinor": 15
  },
  {
    "skuId": "sku_api_resources_resource_balance_api_2026",
    "businessId": "resources",
    "sourceBusinessId": "resources",
    "businessName": "Anchor Resources",
    "name": "Resource Balance API",
    "description": "Sovereign resource balance sheets and depletion modelling",
    "endpointPath": "/api/v1/resource-balance",
    "unitAmountMinor": 25
  },
  {
    "skuId": "sku_api_retail_demand_forecast_api_2026",
    "businessId": "retail",
    "sourceBusinessId": "retail",
    "businessName": "Anchor Retail",
    "name": "Demand Forecast API",
    "description": "SKU-level demand prediction incorporating weather, events, and trend data",
    "endpointPath": "/api/v1/demand-forecast",
    "unitAmountMinor": 15
  },
  {
    "skuId": "sku_api_retail_shrinkage_detection_api_2026",
    "businessId": "retail",
    "sourceBusinessId": "retail",
    "businessName": "Anchor Retail",
    "name": "Shrinkage Detection API",
    "description": "Real-time loss event detection and theft probability scoring",
    "endpointPath": "/api/v1/shrinkage-detect",
    "unitAmountMinor": 20
  },
  {
    "skuId": "sku_api_retail_price_optimise_api_2026",
    "businessId": "retail",
    "sourceBusinessId": "retail",
    "businessName": "Anchor Retail",
    "name": "Price Optimise API",
    "description": "Dynamic pricing recommendations based on competition, elasticity, and margin targets",
    "endpointPath": "/api/v1/price-optimise",
    "unitAmountMinor": 25
  },
  {
    "skuId": "sku_api_retail_customer_segment_api_2026",
    "businessId": "retail",
    "sourceBusinessId": "retail",
    "businessName": "Anchor Retail",
    "name": "Customer Segment API",
    "description": "Privacy-compliant customer segmentation and lifetime value prediction",
    "endpointPath": "/api/v1/customer-segment",
    "unitAmountMinor": 10
  },
  {
    "skuId": "sku_api_sports_match_integrity_api_2026",
    "businessId": "sports",
    "sourceBusinessId": "sports",
    "businessName": "Anchor Sports",
    "name": "Match Integrity API",
    "description": "Real-time match-fixing probability scoring and suspicious pattern detection",
    "endpointPath": "/api/v1/match-integrity",
    "unitAmountMinor": 25
  },
  {
    "skuId": "sku_api_sports_betting_anomaly_api_2026",
    "businessId": "sports",
    "sourceBusinessId": "sports",
    "businessName": "Anchor Sports",
    "name": "Betting Anomaly API",
    "description": "Betting market surveillance and anomalous activity detection",
    "endpointPath": "/api/v1/betting-anomaly",
    "unitAmountMinor": 15
  },
  {
    "skuId": "sku_api_sports_athlete_risk_api_2026",
    "businessId": "sports",
    "sourceBusinessId": "sports",
    "businessName": "Anchor Sports",
    "name": "Athlete Risk API",
    "description": "Injury prediction and doping risk profiling for individual athletes",
    "endpointPath": "/api/v1/athlete-risk",
    "unitAmountMinor": 30
  },
  {
    "skuId": "sku_api_sports_performance_analytics_api_2026",
    "businessId": "sports",
    "sourceBusinessId": "sports",
    "businessName": "Anchor Sports",
    "name": "Performance Analytics API",
    "description": "Biomechanical analysis and performance benchmarking data",
    "endpointPath": "/api/v1/sports-performance",
    "unitAmountMinor": 20
  },
  {
    "skuId": "sku_api_automotive_vin_check_api_2026",
    "businessId": "automotive",
    "sourceBusinessId": "automotive",
    "businessName": "Anchor Automotive",
    "name": "VIN Check API",
    "description": "Deep VIN verification against NEVDIS, PPSR, and stolen vehicle databases",
    "endpointPath": "/api/v1/vin-check",
    "unitAmountMinor": 15
  },
  {
    "skuId": "sku_api_automotive_stolen_vehicle_screen_api_2026",
    "businessId": "automotive",
    "sourceBusinessId": "automotive",
    "businessName": "Anchor Automotive",
    "name": "Stolen Vehicle Screen API",
    "description": "Real-time screening against national stolen vehicle databases",
    "endpointPath": "/api/v1/stolen-screen",
    "unitAmountMinor": 10
  },
  {
    "skuId": "sku_api_automotive_rebirth_detection_api_2026",
    "businessId": "automotive",
    "sourceBusinessId": "automotive",
    "businessName": "Anchor Automotive",
    "name": "Rebirth Detection API",
    "description": "Probability scoring for VIN cloning and vehicle rebirthing",
    "endpointPath": "/api/v1/rebirth-detect",
    "unitAmountMinor": 30
  },
  {
    "skuId": "sku_api_automotive_port_risk_api_2026",
    "businessId": "automotive",
    "sourceBusinessId": "automotive",
    "businessName": "Anchor Automotive",
    "name": "Port Risk API",
    "description": "Container screening and stolen vehicle export risk assessment",
    "endpointPath": "/api/v1/port-risk",
    "unitAmountMinor": 25
  },
  {
    "skuId": "sku_api_insurance_risk_score_api_2026",
    "businessId": "insurance",
    "sourceBusinessId": "insurance",
    "businessName": "Anchor Insurance",
    "name": "Risk Score API",
    "description": "Real-time risk scoring for property, vehicle, and health insurance applications",
    "endpointPath": "/api/v1/risk-score",
    "unitAmountMinor": 25
  },
  {
    "skuId": "sku_api_insurance_fraud_detection_api_2026",
    "businessId": "insurance",
    "sourceBusinessId": "insurance",
    "businessName": "Anchor Insurance",
    "name": "Fraud Detection API",
    "description": "Claims fraud probability scoring and organised fraud ring detection",
    "endpointPath": "/api/v1/insurance-fraud",
    "unitAmountMinor": 30
  },
  {
    "skuId": "sku_api_insurance_catastrophe_model_api_2026",
    "businessId": "insurance",
    "sourceBusinessId": "insurance",
    "businessName": "Anchor Insurance",
    "name": "Catastrophe Model API",
    "description": "Catastrophe loss prediction for specific locations and portfolio exposure",
    "endpointPath": "/api/v1/cat-model",
    "unitAmountMinor": 50
  },
  {
    "skuId": "sku_api_insurance_claims_assessment_api_2026",
    "businessId": "insurance",
    "sourceBusinessId": "insurance",
    "businessName": "Anchor Insurance",
    "name": "Claims Assessment API",
    "description": "Automated claims assessment and settlement recommendation",
    "endpointPath": "/api/v1/claims-assess",
    "unitAmountMinor": 20
  },
  {
    "skuId": "sku_api_logistics_container_track_api_2026",
    "businessId": "logistics",
    "sourceBusinessId": "logistics",
    "businessName": "Anchor Logistics",
    "name": "Container Track API",
    "description": "Real-time container location, condition, and ETA across all transport modes",
    "endpointPath": "/api/v1/container-track",
    "unitAmountMinor": 10
  },
  {
    "skuId": "sku_api_logistics_disruption_predict_api_2026",
    "businessId": "logistics",
    "sourceBusinessId": "logistics",
    "businessName": "Anchor Logistics",
    "name": "Disruption Predict API",
    "description": "Supply chain disruption probability and cascading impact analysis",
    "endpointPath": "/api/v1/disruption-predict",
    "unitAmountMinor": 35
  },
  {
    "skuId": "sku_api_logistics_route_optimise_api_2026",
    "businessId": "logistics",
    "sourceBusinessId": "logistics",
    "businessName": "Anchor Logistics",
    "name": "Route Optimise API",
    "description": "Multi-modal route optimisation with cost, time, carbon, and risk scoring",
    "endpointPath": "/api/v1/route-optimise",
    "unitAmountMinor": 25
  },
  {
    "skuId": "sku_api_logistics_customs_risk_api_2026",
    "businessId": "logistics",
    "sourceBusinessId": "logistics",
    "businessName": "Anchor Logistics",
    "name": "Customs Risk API",
    "description": "Customs clearance risk profiling and document verification",
    "endpointPath": "/api/v1/customs-risk",
    "unitAmountMinor": 15
  },
  {
    "skuId": "sku_api_smartcity_traffic_flow_api_2026",
    "businessId": "smartcity",
    "sourceBusinessId": "smartcity",
    "businessName": "Anchor Smart City",
    "name": "Traffic Flow API",
    "description": "Real-time traffic congestion data and signal optimisation recommendations",
    "endpointPath": "/api/v1/traffic-flow",
    "unitAmountMinor": 10
  },
  {
    "skuId": "sku_api_smartcity_safety_score_api_2026",
    "businessId": "smartcity",
    "sourceBusinessId": "smartcity",
    "businessName": "Anchor Smart City",
    "name": "Safety Score API",
    "description": "Neighbourhood safety scoring and crime prediction for any location",
    "endpointPath": "/api/v1/safety-score",
    "unitAmountMinor": 15
  },
  {
    "skuId": "sku_api_smartcity_grid_demand_api_2026",
    "businessId": "smartcity",
    "sourceBusinessId": "smartcity",
    "businessName": "Anchor Smart City",
    "name": "Grid Demand API",
    "description": "Energy demand prediction and grid stress assessment",
    "endpointPath": "/api/v1/grid-demand",
    "unitAmountMinor": 20
  },
  {
    "skuId": "sku_api_smartcity_urban_environment_api_2026",
    "businessId": "smartcity",
    "sourceBusinessId": "smartcity",
    "businessName": "Anchor Smart City",
    "name": "Urban Environment API",
    "description": "Air quality, noise, and environmental data for any urban location",
    "endpointPath": "/api/v1/urban-environment",
    "unitAmountMinor": 10
  },
  {
    "skuId": "sku_api_social_bot_detection_api_2026",
    "businessId": "social",
    "sourceBusinessId": "social",
    "businessName": "Anchor Social",
    "name": "Bot Detection API",
    "description": "Real-time bot probability scoring for any social media account",
    "endpointPath": "/api/v1/bot-detect",
    "unitAmountMinor": 10
  },
  {
    "skuId": "sku_api_social_deepfake_screen_api_2026",
    "businessId": "social",
    "sourceBusinessId": "social",
    "businessName": "Anchor Social",
    "name": "Deepfake Screen API",
    "description": "AI-generated content detection for images, video, and audio",
    "endpointPath": "/api/v1/deepfake-screen",
    "unitAmountMinor": 50
  },
  {
    "skuId": "sku_api_social_influence_map_api_2026",
    "businessId": "social",
    "sourceBusinessId": "social",
    "businessName": "Anchor Social",
    "name": "Influence Map API",
    "description": "Identify coordinated campaigns and map influence networks",
    "endpointPath": "/api/v1/influence-map",
    "unitAmountMinor": 35
  },
  {
    "skuId": "sku_api_social_narrative_track_api_2026",
    "businessId": "social",
    "sourceBusinessId": "social",
    "businessName": "Anchor Social",
    "name": "Narrative Track API",
    "description": "Track narrative spread paths and identify coordination signals",
    "endpointPath": "/api/v1/narrative-track",
    "unitAmountMinor": 20
  },
  {
    "skuId": "sku_api_agroshield_compliance_check_api_2026",
    "businessId": "agroshield",
    "sourceBusinessId": "agroshield",
    "businessName": "Anchor AgroShield",
    "name": "Compliance Check API",
    "description": "Regulatory compliance verification across jurisdictions",
    "endpointPath": "/api/v1/agroshield-compliance",
    "unitAmountMinor": 20
  },
  {
    "skuId": "sku_api_agroshield_batch_provenance_api_2026",
    "businessId": "agroshield",
    "sourceBusinessId": "agroshield",
    "businessName": "Anchor AgroShield",
    "name": "Batch Provenance API",
    "description": "Supply chain tracking and batch verification",
    "endpointPath": "/api/v1/agroshield-provenance",
    "unitAmountMinor": 15
  },
  {
    "skuId": "sku_api_bioagri_pathogen_alert_api_2026",
    "businessId": "bioagri",
    "sourceBusinessId": "bioagri",
    "businessName": "Anchor BioAgri",
    "name": "Pathogen Alert API",
    "description": "Real-time pathogen detection and biosecurity alerts",
    "endpointPath": "/api/v1/bioagri-pathogen",
    "unitAmountMinor": 25
  },
  {
    "skuId": "sku_api_water_scada_monitor_api_2026",
    "businessId": "water",
    "sourceBusinessId": "water-utilities",
    "businessName": "Anchor Water",
    "name": "SCADA Monitor API",
    "description": "Real-time SCADA device integrity monitoring",
    "endpointPath": "/api/v1/water-scada",
    "unitAmountMinor": 30
  },
  {
    "skuId": "sku_api_blackflight_flight_risk_api_2026",
    "businessId": "blackflight",
    "sourceBusinessId": "blackflight",
    "businessName": "Anchor Blackflight",
    "name": "Flight Risk API",
    "description": "Suspicious flight pattern scoring and alert",
    "endpointPath": "/api/v1/blackflight-risk",
    "unitAmountMinor": 100
  },
  {
    "skuId": "sku_api_humankind_disaster_alert_api_2026",
    "businessId": "humankind",
    "sourceBusinessId": "humankind",
    "businessName": "Anchor HumanKind",
    "name": "Disaster Alert API",
    "description": "Real-time disaster prediction and warning",
    "endpointPath": "/api/v1/humankind-disaster",
    "unitAmountMinor": 10
  },
  {
    "skuId": "sku_api_semiconductor_chip_trace_api_2026",
    "businessId": "semiconductor",
    "sourceBusinessId": "semiconductor",
    "businessName": "Anchor Semiconductor",
    "name": "Chip Trace API",
    "description": "Chip provenance verification and counterfeit scoring",
    "endpointPath": "/api/v1/semiconductor-trace",
    "unitAmountMinor": 50
  },
  {
    "skuId": "sku_api_quantum_pqc_assessment_api_2026",
    "businessId": "quantum",
    "sourceBusinessId": "quantum",
    "businessName": "Anchor Quantum",
    "name": "PQC Assessment API",
    "description": "Quantum vulnerability scoring for encryption implementations",
    "endpointPath": "/api/v1/quantum-assess",
    "unitAmountMinor": 50
  },
  {
    "skuId": "sku_api_fuel_pipeline_threat_api_2026",
    "businessId": "fuel",
    "sourceBusinessId": "fuel",
    "businessName": "Anchor Fuel",
    "name": "Pipeline Threat API",
    "description": "Real-time SCADA anomaly detection and threat scoring for pipeline networks",
    "endpointPath": "/api/v1/fuel-pipeline-threat",
    "unitAmountMinor": 35
  },
  {
    "skuId": "sku_api_fuel_fuel_market_integrity_api_2026",
    "businessId": "fuel",
    "sourceBusinessId": "fuel",
    "businessName": "Anchor Fuel",
    "name": "Fuel Market Integrity API",
    "description": "Price manipulation and wash-trading detection across fuel benchmarks",
    "endpointPath": "/api/v1/fuel-market-integrity",
    "unitAmountMinor": 50
  },
  {
    "skuId": "sku_api_kinetic_effector_status_api_2026",
    "businessId": "kinetic",
    "sourceBusinessId": "kinetic",
    "businessName": "Anchor Kinetic",
    "name": "Effector Status API",
    "description": "Real-time smart effector readiness, location, and status intelligence",
    "endpointPath": "/api/v1/kinetic-effector-status",
    "unitAmountMinor": 100
  },
  {
    "skuId": "sku_api_kinetic_firewall_audit_api_2026",
    "businessId": "kinetic",
    "sourceBusinessId": "kinetic",
    "businessName": "Anchor Kinetic",
    "name": "Firewall Audit API",
    "description": "PID ethical firewall check results and immutable audit records",
    "endpointPath": "/api/v1/kinetic-firewall-audit",
    "unitAmountMinor": 75
  },
  {
    "skuId": "sku_api_agri_field_monitoring_api_2026",
    "businessId": "agri",
    "sourceBusinessId": "agri",
    "businessName": "Anchor Agri",
    "name": "Field Monitoring API",
    "description": "Satellite-based crop health and anomaly detection",
    "endpointPath": "/api/agri/field-monitor",
    "unitAmountMinor": 5
  },
  {
    "skuId": "sku_api_agri_pest_prediction_api_2026",
    "businessId": "agri",
    "sourceBusinessId": "agri",
    "businessName": "Anchor Agri",
    "name": "Pest Prediction API",
    "description": "ML-powered pest and disease outbreak predictions",
    "endpointPath": "/api/agri/pest-predict",
    "unitAmountMinor": 8
  },
  {
    "skuId": "sku_api_agri_supply_chain_api_2026",
    "businessId": "agri",
    "sourceBusinessId": "agri",
    "businessName": "Anchor Agri",
    "name": "Supply Chain API",
    "description": "End-to-end food supply chain tracking",
    "endpointPath": "/api/agri/supply-chain",
    "unitAmountMinor": 4
  },
  {
    "skuId": "sku_api_biotech_biotech_risk_api_2026",
    "businessId": "biotech",
    "sourceBusinessId": "biotech",
    "businessName": "Anchor Biotech",
    "name": "Biotech Risk API",
    "description": "Program risk, lab anomaly, and data exposure scoring",
    "endpointPath": "/api/biotech/risks",
    "unitAmountMinor": 7
  },
  {
    "skuId": "sku_api_infrastructure_infrastructure_risk_api_2026",
    "businessId": "infrastructure",
    "sourceBusinessId": "infrastructure",
    "businessName": "Anchor Infrastructure",
    "name": "Infrastructure Risk API",
    "description": "Asset risk, outage, and dependency scoring",
    "endpointPath": "/api/infrastructure/risks",
    "unitAmountMinor": 8
  },
  {
    "skuId": "sku_api_telecom_tower_threat_api_2026",
    "businessId": "telecom",
    "sourceBusinessId": "telecom",
    "businessName": "Anchor Telecom",
    "name": "Tower Threat API",
    "description": "Real-time cell tower security monitoring and anomaly detection",
    "endpointPath": "/api/v1/telecom-tower-threat",
    "unitAmountMinor": 25
  },
  {
    "skuId": "sku_api_telecom_sim_fraud_api_2026",
    "businessId": "telecom",
    "sourceBusinessId": "telecom",
    "businessName": "Anchor Telecom",
    "name": "SIM Fraud API",
    "description": "SIM-swap and number-porting fraud detection for carriers",
    "endpointPath": "/api/v1/telecom-sim-fraud",
    "unitAmountMinor": 40
  },
  {
    "skuId": "sku_api_water_water_risk_api_2026",
    "businessId": "water",
    "sourceBusinessId": "water",
    "businessName": "Anchor Water Intelligence",
    "name": "Water Risk API",
    "description": "Telemetry anomaly scoring and contamination detection",
    "endpointPath": "/api/water/quality",
    "unitAmountMinor": 5
  }
] as const;

export const GENERATED_SECTOR_TIERS = [
  {
    "skuId": "sku_sector_medical_researcher_2026",
    "businessId": "medical",
    "sourceBusinessId": "medical",
    "businessName": "Anchor Medical",
    "name": "Researcher",
    "unitAmountMinor": 299000,
    "billingInterval": "month",
    "features": [
      "5 users",
      "Literature scanning",
      "Adverse event alerts",
      "Basic dashboards",
      "Email support"
    ],
    "callToAction": "Request demo"
  },
  {
    "skuId": "sku_sector_medical_institution_2026",
    "businessId": "medical",
    "sourceBusinessId": "medical",
    "businessName": "Anchor Medical",
    "name": "Institution",
    "unitAmountMinor": 999000,
    "billingInterval": "month",
    "features": [
      "25 users",
      "Everything in Researcher",
      "Drug repurposing engine",
      "Clinical trial monitoring",
      "API access",
      "Priority support"
    ],
    "callToAction": "Request demo"
  },
  {
    "skuId": "sku_sector_medical_enterprise_2026",
    "businessId": "medical",
    "sourceBusinessId": "medical",
    "businessName": "Anchor Medical",
    "name": "Enterprise",
    "unitAmountMinor": 2999000,
    "billingInterval": "month",
    "features": [
      "Unlimited users",
      "Everything in Institution",
      "Cross-sector correlations",
      "Custom AI models",
      "On-premise deployment",
      "Dedicated account manager",
      "99.9% SLA"
    ],
    "callToAction": "Contact Sales"
  },
  {
    "skuId": "sku_sector_finance_analyst_2026",
    "businessId": "finance",
    "sourceBusinessId": "finance",
    "businessName": "Anchor Finance",
    "name": "Analyst",
    "unitAmountMinor": 499000,
    "billingInterval": "month",
    "features": [
      "5 users",
      "Market monitoring",
      "Filing analysis",
      "Basic dashboards",
      "Email alerts"
    ],
    "callToAction": "Request demo"
  },
  {
    "skuId": "sku_sector_finance_professional_2026",
    "businessId": "finance",
    "sourceBusinessId": "finance",
    "businessName": "Anchor Finance",
    "name": "Professional",
    "unitAmountMinor": 1499000,
    "billingInterval": "month",
    "features": [
      "25 users",
      "Everything in Analyst",
      "Predictive signals",
      "Cross-asset correlation",
      "API access",
      "Priority support"
    ],
    "callToAction": "Request demo"
  },
  {
    "skuId": "sku_sector_finance_enterprise_2026",
    "businessId": "finance",
    "sourceBusinessId": "finance",
    "businessName": "Anchor Finance",
    "name": "Enterprise",
    "unitAmountMinor": 4999000,
    "billingInterval": "month",
    "features": [
      "Unlimited users",
      "Everything in Professional",
      "Custom AI models",
      "Flash event detection",
      "On-premise deployment",
      "Dedicated analyst",
      "99.99% SLA"
    ],
    "callToAction": "Contact Sales"
  },
  {
    "skuId": "sku_sector_legal_practitioner_2026",
    "businessId": "legal",
    "sourceBusinessId": "legal",
    "businessName": "Anchor Legal",
    "name": "Practitioner",
    "unitAmountMinor": 399000,
    "billingInterval": "month",
    "features": [
      "5 users",
      "Regulatory tracking",
      "Case law search",
      "Basic alerts",
      "Email support"
    ],
    "callToAction": "Request demo"
  },
  {
    "skuId": "sku_sector_legal_firm_2026",
    "businessId": "legal",
    "sourceBusinessId": "legal",
    "businessName": "Anchor Legal",
    "name": "Firm",
    "unitAmountMinor": 1299000,
    "billingInterval": "month",
    "features": [
      "25 users",
      "Everything in Practitioner",
      "Predictive analysis",
      "Contract review AI",
      "API access",
      "Priority support"
    ],
    "callToAction": "Request demo"
  },
  {
    "skuId": "sku_sector_legal_enterprise_2026",
    "businessId": "legal",
    "sourceBusinessId": "legal",
    "businessName": "Anchor Legal",
    "name": "Enterprise",
    "unitAmountMinor": 3999000,
    "billingInterval": "month",
    "features": [
      "Unlimited users",
      "Everything in Firm",
      "Cross-jurisdiction analysis",
      "Custom AI models",
      "On-premise",
      "Dedicated legal analyst"
    ],
    "callToAction": "Contact Sales"
  },
  {
    "skuId": "sku_sector_climate_analyst_2026",
    "businessId": "climate",
    "sourceBusinessId": "climate",
    "businessName": "Anchor Climate",
    "name": "Analyst",
    "unitAmountMinor": 349000,
    "billingInterval": "month",
    "features": [
      "5 users",
      "Climate monitoring",
      "Carbon dashboard",
      "Basic reporting",
      "Email support"
    ],
    "callToAction": "Request demo"
  },
  {
    "skuId": "sku_sector_climate_professional_2026",
    "businessId": "climate",
    "sourceBusinessId": "climate",
    "businessName": "Anchor Climate",
    "name": "Professional",
    "unitAmountMinor": 1199000,
    "billingInterval": "month",
    "features": [
      "25 users",
      "Everything in Analyst",
      "Risk prediction",
      "Transition analysis",
      "API access",
      "Priority support"
    ],
    "callToAction": "Request demo"
  },
  {
    "skuId": "sku_sector_climate_enterprise_2026",
    "businessId": "climate",
    "sourceBusinessId": "climate",
    "businessName": "Anchor Climate",
    "name": "Enterprise",
    "unitAmountMinor": 3499000,
    "billingInterval": "month",
    "features": [
      "Unlimited users",
      "Everything in Professional",
      "Asset-level risk models",
      "Custom AI models",
      "On-premise",
      "Dedicated analyst"
    ],
    "callToAction": "Contact Sales"
  },
  {
    "skuId": "sku_sector_defence_analyst_2026",
    "businessId": "defence",
    "sourceBusinessId": "defence",
    "businessName": "Anchor Defence",
    "name": "Analyst",
    "unitAmountMinor": 999000,
    "billingInterval": "month",
    "features": [
      "5 users",
      "OSINT monitoring",
      "Geopolitical tracking",
      "Basic dashboards",
      "Secure support"
    ],
    "callToAction": "Request Access"
  },
  {
    "skuId": "sku_sector_defence_command_2026",
    "businessId": "defence",
    "sourceBusinessId": "defence",
    "businessName": "Anchor Defence",
    "name": "Command",
    "unitAmountMinor": 4999000,
    "billingInterval": "month",
    "features": [
      "50 users",
      "Everything in Analyst",
      "Multi-domain correlation",
      "Adversary prediction",
      "API access",
      "Priority support"
    ],
    "callToAction": "Request Access"
  },
  {
    "skuId": "sku_sector_defence_sovereign_2026",
    "businessId": "defence",
    "sourceBusinessId": "defence",
    "businessName": "Anchor Defence",
    "name": "Sovereign",
    "unitAmountMinor": null,
    "billingInterval": "month",
    "features": [
      "Unlimited users",
      "Everything in Command",
      "Air-gapped deployment",
      "Custom AI models",
      "On-premise / classified",
      "Dedicated intelligence team",
      "National-scale telemetry"
    ],
    "callToAction": "Contact Defence Sales"
  },
  {
    "skuId": "sku_sector_energy_analyst_2026",
    "businessId": "energy",
    "sourceBusinessId": "energy",
    "businessName": "Anchor Energy",
    "name": "Analyst",
    "unitAmountMinor": 449000,
    "billingInterval": "month",
    "features": [
      "5 users",
      "Market monitoring",
      "Price alerts",
      "Basic dashboards",
      "Email support"
    ],
    "callToAction": "Request demo"
  },
  {
    "skuId": "sku_sector_energy_operator_2026",
    "businessId": "energy",
    "sourceBusinessId": "energy",
    "businessName": "Anchor Energy",
    "name": "Operator",
    "unitAmountMinor": 1499000,
    "billingInterval": "month",
    "features": [
      "25 users",
      "Everything in Analyst",
      "Grid intelligence",
      "Supply prediction",
      "API access",
      "Priority support"
    ],
    "callToAction": "Request demo"
  },
  {
    "skuId": "sku_sector_energy_enterprise_2026",
    "businessId": "energy",
    "sourceBusinessId": "energy",
    "businessName": "Anchor Energy",
    "name": "Enterprise",
    "unitAmountMinor": 3999000,
    "billingInterval": "month",
    "features": [
      "Unlimited users",
      "Everything in Operator",
      "Custom AI models",
      "On-premise deployment",
      "Dedicated analyst",
      "99.9% SLA"
    ],
    "callToAction": "Contact Sales"
  },
  {
    "skuId": "sku_sector_maritime_operator_2026",
    "businessId": "maritime",
    "sourceBusinessId": "maritime",
    "businessName": "Anchor Maritime",
    "name": "Operator",
    "unitAmountMinor": 499000,
    "billingInterval": "month",
    "features": [
      "5 users",
      "Vessel tracking",
      "Port monitoring",
      "Weather alerts",
      "Email support"
    ],
    "callToAction": "Request demo"
  },
  {
    "skuId": "sku_sector_maritime_fleet_2026",
    "businessId": "maritime",
    "sourceBusinessId": "maritime",
    "businessName": "Anchor Maritime",
    "name": "Fleet",
    "unitAmountMinor": 1499000,
    "billingInterval": "month",
    "features": [
      "25 users",
      "Everything in Operator",
      "Security intelligence",
      "Route optimisation",
      "API access",
      "Priority support"
    ],
    "callToAction": "Request demo"
  },
  {
    "skuId": "sku_sector_maritime_enterprise_2026",
    "businessId": "maritime",
    "sourceBusinessId": "maritime",
    "businessName": "Anchor Maritime",
    "name": "Enterprise",
    "unitAmountMinor": 3999000,
    "billingInterval": "month",
    "features": [
      "Unlimited users",
      "Everything in Fleet",
      "Sanctions screening",
      "Custom AI models",
      "On-premise",
      "Dedicated analyst"
    ],
    "callToAction": "Contact Sales"
  },
  {
    "skuId": "sku_sector_space_operator_2026",
    "businessId": "space",
    "sourceBusinessId": "space",
    "businessName": "Anchor Space",
    "name": "Operator",
    "unitAmountMinor": 999000,
    "billingInterval": "month",
    "features": [
      "5 users",
      "Satellite tracking",
      "Conjunction alerts",
      "Basic dashboards",
      "Email support"
    ],
    "callToAction": "Request demo"
  },
  {
    "skuId": "sku_sector_space_constellation_2026",
    "businessId": "space",
    "sourceBusinessId": "space",
    "businessName": "Anchor Space",
    "name": "Constellation",
    "unitAmountMinor": 2999000,
    "billingInterval": "month",
    "features": [
      "25 users",
      "Everything in Operator",
      "ASAT monitoring",
      "Debris prediction",
      "API access",
      "Priority support"
    ],
    "callToAction": "Request demo"
  },
  {
    "skuId": "sku_sector_space_sovereign_2026",
    "businessId": "space",
    "sourceBusinessId": "space",
    "businessName": "Anchor Space",
    "name": "Sovereign",
    "unitAmountMinor": null,
    "billingInterval": "month",
    "features": [
      "Unlimited users",
      "Everything in Constellation",
      "Air-gapped deployment",
      "Custom orbital models",
      "On-premise",
      "Dedicated space analyst"
    ],
    "callToAction": "Contact Sales"
  },
  {
    "skuId": "sku_sector_agriculture_farm_2026",
    "businessId": "agriculture",
    "sourceBusinessId": "agriculture",
    "businessName": "Anchor Agriculture",
    "name": "Farm",
    "unitAmountMinor": 199000,
    "billingInterval": "month",
    "features": [
      "5 users",
      "Crop monitoring",
      "Weather alerts",
      "Basic dashboards",
      "Email support"
    ],
    "callToAction": "Request demo"
  },
  {
    "skuId": "sku_sector_agriculture_enterprise_2026",
    "businessId": "agriculture",
    "sourceBusinessId": "agriculture",
    "businessName": "Anchor Agriculture",
    "name": "Enterprise",
    "unitAmountMinor": 999000,
    "billingInterval": "month",
    "features": [
      "25 users",
      "Everything in Farm",
      "Commodity intelligence",
      "Pest prediction",
      "API access",
      "Priority support"
    ],
    "callToAction": "Request demo"
  },
  {
    "skuId": "sku_sector_agriculture_government_2026",
    "businessId": "agriculture",
    "sourceBusinessId": "agriculture",
    "businessName": "Anchor Agriculture",
    "name": "Government",
    "unitAmountMinor": 2999000,
    "billingInterval": "month",
    "features": [
      "Unlimited users",
      "Everything in Enterprise",
      "National-scale monitoring",
      "Custom AI models",
      "On-premise",
      "Dedicated analyst"
    ],
    "callToAction": "Contact Sales"
  },
  {
    "skuId": "sku_sector_education_institution_2026",
    "businessId": "education",
    "sourceBusinessId": "education",
    "businessName": "Anchor Education",
    "name": "Institution",
    "unitAmountMinor": 149000,
    "billingInterval": "month",
    "features": [
      "10 users",
      "Curriculum analysis",
      "Skills gap reports",
      "Basic dashboards",
      "Email support"
    ],
    "callToAction": "Request demo"
  },
  {
    "skuId": "sku_sector_education_district_2026",
    "businessId": "education",
    "sourceBusinessId": "education",
    "businessName": "Anchor Education",
    "name": "District",
    "unitAmountMinor": 499000,
    "billingInterval": "month",
    "features": [
      "50 users",
      "Everything in Institution",
      "Outcome prediction",
      "Policy modelling",
      "API access",
      "Priority support"
    ],
    "callToAction": "Request demo"
  },
  {
    "skuId": "sku_sector_education_government_2026",
    "businessId": "education",
    "sourceBusinessId": "education",
    "businessName": "Anchor Education",
    "name": "Government",
    "unitAmountMinor": 1999000,
    "billingInterval": "month",
    "features": [
      "Unlimited users",
      "Everything in District",
      "National benchmarking",
      "Custom AI models",
      "On-premise",
      "Dedicated analyst"
    ],
    "callToAction": "Contact Sales"
  },
  {
    "skuId": "sku_sector_leo_regional_agency_2026",
    "businessId": "leo",
    "sourceBusinessId": "leo",
    "businessName": "Anchor LEO",
    "name": "Regional Agency",
    "unitAmountMinor": 2499000,
    "billingInterval": "month",
    "features": [
      "25 users",
      "Case management",
      "Evidence vault",
      "Basic intelligence",
      "State jurisdiction compliance",
      "Priority support"
    ],
    "callToAction": "Request Access"
  },
  {
    "skuId": "sku_sector_leo_federal_agency_2026",
    "businessId": "leo",
    "sourceBusinessId": "leo",
    "businessName": "Anchor LEO",
    "name": "Federal Agency",
    "unitAmountMinor": 9999000,
    "billingInterval": "month",
    "features": [
      "250 users",
      "Everything in Regional",
      "Multi-jurisdiction coordination",
      "Cryptocurrency tracing",
      "Interpol integration",
      "API access",
      "Dedicated analyst"
    ],
    "callToAction": "Request Access"
  },
  {
    "skuId": "sku_sector_leo_national_bureau_2026",
    "businessId": "leo",
    "sourceBusinessId": "leo",
    "businessName": "Anchor LEO",
    "name": "National Bureau",
    "unitAmountMinor": null,
    "billingInterval": "year",
    "features": [
      "Unlimited users",
      "Everything in Federal",
      "Five Eyes integration",
      "On-premise deployment",
      "Custom AI models",
      "Classified intelligence tier",
      "99.99% SLA",
      "Joint Operations Centre access"
    ],
    "callToAction": "Contact Director"
  },
  {
    "skuId": "sku_sector_wildlife_reserve_2026",
    "businessId": "wildlife",
    "sourceBusinessId": "wildlife",
    "businessName": "Anchor Wildlife",
    "name": "Reserve",
    "unitAmountMinor": 499000,
    "billingInterval": "month",
    "features": [
      "1 reserve",
      "Poaching alerts",
      "Species tracking",
      "Basic ranger dispatch",
      "Email support"
    ],
    "callToAction": "Request demo"
  },
  {
    "skuId": "sku_sector_wildlife_conservation_2026",
    "businessId": "wildlife",
    "sourceBusinessId": "wildlife",
    "businessName": "Anchor Wildlife",
    "name": "Conservation",
    "unitAmountMinor": 1499000,
    "billingInterval": "month",
    "features": [
      "5 reserves",
      "Everything in Reserve",
      "Trafficking intel",
      "Cross-sector integration",
      "API access",
      "Priority support"
    ],
    "callToAction": "Request demo"
  },
  {
    "skuId": "sku_sector_wildlife_sovereign_2026",
    "businessId": "wildlife",
    "sourceBusinessId": "wildlife",
    "businessName": "Anchor Wildlife",
    "name": "Sovereign",
    "unitAmountMinor": 4999000,
    "billingInterval": "month",
    "features": [
      "Unlimited reserves",
      "Everything in Conservation",
      "Satellite monitoring",
      "INTERPOL integration",
      "Custom AI models",
      "On-premise deployment",
      "99.9% SLA"
    ],
    "callToAction": "Contact Sales"
  },
  {
    "skuId": "sku_sector_casino_property_2026",
    "businessId": "casino",
    "sourceBusinessId": "casino",
    "businessName": "Anchor Casino",
    "name": "Property",
    "unitAmountMinor": 999000,
    "billingInterval": "month",
    "features": [
      "1 property",
      "Fraud detection",
      "Surveillance AI",
      "AML monitoring",
      "Email support"
    ],
    "callToAction": "Request demo"
  },
  {
    "skuId": "sku_sector_casino_resort_2026",
    "businessId": "casino",
    "sourceBusinessId": "casino",
    "businessName": "Anchor Casino",
    "name": "Resort",
    "unitAmountMinor": 2999000,
    "billingInterval": "month",
    "features": [
      "5 properties",
      "Everything in Property",
      "Cross-property intel",
      "Regulatory automation",
      "API access",
      "Priority support"
    ],
    "callToAction": "Request demo"
  },
  {
    "skuId": "sku_sector_casino_sovereign_2026",
    "businessId": "casino",
    "sourceBusinessId": "casino",
    "businessName": "Anchor Casino",
    "name": "Sovereign",
    "unitAmountMinor": 8999000,
    "billingInterval": "month",
    "features": [
      "Unlimited properties",
      "Everything in Resort",
      "Predictive modelling",
      "Custom AI models",
      "On-premise deployment",
      "Dedicated analyst team",
      "99.9% SLA"
    ],
    "callToAction": "Contact Sales"
  },
  {
    "skuId": "sku_sector_interpol_regional_bureau_2026",
    "businessId": "interpol",
    "sourceBusinessId": "interpol",
    "businessName": "Anchor Interpol",
    "name": "Regional Bureau",
    "unitAmountMinor": 7499000,
    "billingInterval": "month",
    "features": [
      "1 regional bureau",
      "Red Notice intelligence",
      "Cybercrime monitoring",
      "Fugitive tracking",
      "Priority support"
    ],
    "callToAction": "Request Access"
  },
  {
    "skuId": "sku_sector_interpol_continental_command_2026",
    "businessId": "interpol",
    "sourceBusinessId": "interpol",
    "businessName": "Anchor Interpol",
    "name": "Continental Command",
    "unitAmountMinor": 24999000,
    "billingInterval": "month",
    "features": [
      "Continental coverage",
      "Everything in Regional",
      "Counter-terrorism",
      "Trafficking disruption",
      "Dark web OSINT",
      "API access"
    ],
    "callToAction": "Request Access"
  },
  {
    "skuId": "sku_sector_interpol_sovereign_global_2026",
    "businessId": "interpol",
    "sourceBusinessId": "interpol",
    "businessName": "Anchor Interpol",
    "name": "Sovereign Global",
    "unitAmountMinor": null,
    "billingInterval": "month",
    "features": [
      "194-nation coverage",
      "Everything in Continental",
      "Predictive models",
      "Custom AI training",
      "Sovereign deployment",
      "Dedicated intelligence team",
      "99.99% SLA"
    ],
    "callToAction": "Contact Command"
  },
  {
    "skuId": "sku_sector_aviation_regional_2026",
    "businessId": "aviation",
    "sourceBusinessId": "aviation",
    "businessName": "Anchor Aviation",
    "name": "Regional",
    "unitAmountMinor": 499000,
    "billingInterval": "month",
    "features": [
      "5 users",
      "Flight monitoring",
      "Weather integration",
      "Basic dashboards",
      "Email support"
    ],
    "callToAction": "Request demo"
  },
  {
    "skuId": "sku_sector_aviation_airline_2026",
    "businessId": "aviation",
    "sourceBusinessId": "aviation",
    "businessName": "Anchor Aviation",
    "name": "Airline",
    "unitAmountMinor": 1499000,
    "billingInterval": "month",
    "features": [
      "50 users",
      "Everything in Regional",
      "Predictive maintenance",
      "Route optimisation",
      "API access",
      "Priority support"
    ],
    "callToAction": "Request demo"
  },
  {
    "skuId": "sku_sector_aviation_enterprise_2026",
    "businessId": "aviation",
    "sourceBusinessId": "aviation",
    "businessName": "Anchor Aviation",
    "name": "Enterprise",
    "unitAmountMinor": 3999000,
    "billingInterval": "month",
    "features": [
      "Unlimited users",
      "Everything in Airline",
      "Airspace threat detection",
      "Custom AI models",
      "On-premise deployment",
      "Dedicated account manager",
      "99.9% SLA"
    ],
    "callToAction": "Contact Sales"
  },
  {
    "skuId": "sku_sector_charity_foundation_2026",
    "businessId": "charity",
    "sourceBusinessId": "charity",
    "businessName": "Anchor Charity",
    "name": "Foundation",
    "unitAmountMinor": 199000,
    "billingInterval": "month",
    "features": [
      "5 users",
      "Fund tracking",
      "Basic impact reports",
      "Compliance alerts",
      "Email support"
    ],
    "callToAction": "Request demo"
  },
  {
    "skuId": "sku_sector_charity_organisation_2026",
    "businessId": "charity",
    "sourceBusinessId": "charity",
    "businessName": "Anchor Charity",
    "name": "Organisation",
    "unitAmountMinor": 699000,
    "billingInterval": "month",
    "features": [
      "25 users",
      "Everything in Foundation",
      "Fraud detection",
      "Multi-programme tracking",
      "API access",
      "Priority support"
    ],
    "callToAction": "Request demo"
  },
  {
    "skuId": "sku_sector_charity_global_2026",
    "businessId": "charity",
    "sourceBusinessId": "charity",
    "businessName": "Anchor Charity",
    "name": "Global",
    "unitAmountMinor": 1999000,
    "billingInterval": "month",
    "features": [
      "Unlimited users",
      "Everything in Organisation",
      "Disaster coordination",
      "Custom AI models",
      "White-label reporting",
      "Dedicated account manager",
      "99.9% SLA"
    ],
    "callToAction": "Contact Sales"
  },
  {
    "skuId": "sku_sector_crypto_analyst_2026",
    "businessId": "crypto",
    "sourceBusinessId": "crypto",
    "businessName": "Anchor Crypto",
    "name": "Analyst",
    "unitAmountMinor": 399000,
    "billingInterval": "month",
    "features": [
      "5 users",
      "Multi-chain tracing",
      "Wallet screening",
      "Basic dashboards",
      "Email support"
    ],
    "callToAction": "Request demo"
  },
  {
    "skuId": "sku_sector_crypto_exchange_2026",
    "businessId": "crypto",
    "sourceBusinessId": "crypto",
    "businessName": "Anchor Crypto",
    "name": "Exchange",
    "unitAmountMinor": 1499000,
    "billingInterval": "month",
    "features": [
      "50 users",
      "Everything in Analyst",
      "AML automation",
      "Rug pull alerts",
      "API access",
      "Priority support"
    ],
    "callToAction": "Request demo"
  },
  {
    "skuId": "sku_sector_crypto_enterprise_2026",
    "businessId": "crypto",
    "sourceBusinessId": "crypto",
    "businessName": "Anchor Crypto",
    "name": "Enterprise",
    "unitAmountMinor": 4999000,
    "billingInterval": "month",
    "features": [
      "Unlimited users",
      "Everything in Exchange",
      "De-anonymisation engine",
      "Custom AI models",
      "On-premise deployment",
      "Dedicated account manager",
      "99.9% SLA"
    ],
    "callToAction": "Contact Sales"
  },
  {
    "skuId": "sku_sector_entertainment_creator_2026",
    "businessId": "entertainment",
    "sourceBusinessId": "entertainment",
    "businessName": "Anchor Entertainment",
    "name": "Creator",
    "unitAmountMinor": 299000,
    "billingInterval": "month",
    "features": [
      "5 users",
      "Audience analytics",
      "Content performance",
      "Basic dashboards",
      "Email support"
    ],
    "callToAction": "Request demo"
  },
  {
    "skuId": "sku_sector_entertainment_studio_2026",
    "businessId": "entertainment",
    "sourceBusinessId": "entertainment",
    "businessName": "Anchor Entertainment",
    "name": "Studio",
    "unitAmountMinor": 1299000,
    "billingInterval": "month",
    "features": [
      "50 users",
      "Everything in Creator",
      "Prediction engine",
      "Anti-piracy monitoring",
      "API access",
      "Priority support"
    ],
    "callToAction": "Request demo"
  },
  {
    "skuId": "sku_sector_entertainment_enterprise_2026",
    "businessId": "entertainment",
    "sourceBusinessId": "entertainment",
    "businessName": "Anchor Entertainment",
    "name": "Enterprise",
    "unitAmountMinor": 3999000,
    "billingInterval": "month",
    "features": [
      "Unlimited users",
      "Everything in Studio",
      "Cross-platform intelligence",
      "Custom AI models",
      "White-label analytics",
      "Dedicated account manager",
      "99.9% SLA"
    ],
    "callToAction": "Contact Sales"
  },
  {
    "skuId": "sku_sector_mining_explorer_2026",
    "businessId": "mining",
    "sourceBusinessId": "mining",
    "businessName": "Anchor Mining",
    "name": "Explorer",
    "unitAmountMinor": 499000,
    "billingInterval": "month",
    "features": [
      "5 users",
      "Geological mapping",
      "Tenement tracking",
      "Basic dashboards",
      "Email support"
    ],
    "callToAction": "Request demo"
  },
  {
    "skuId": "sku_sector_mining_operator_2026",
    "businessId": "mining",
    "sourceBusinessId": "mining",
    "businessName": "Anchor Mining",
    "name": "Operator",
    "unitAmountMinor": 1999000,
    "billingInterval": "month",
    "features": [
      "50 users",
      "Everything in Explorer",
      "Safety monitoring",
      "Equipment optimisation",
      "API access",
      "Priority support"
    ],
    "callToAction": "Request demo"
  },
  {
    "skuId": "sku_sector_mining_enterprise_2026",
    "businessId": "mining",
    "sourceBusinessId": "mining",
    "businessName": "Anchor Mining",
    "name": "Enterprise",
    "unitAmountMinor": 5999000,
    "billingInterval": "month",
    "features": [
      "Unlimited users",
      "Everything in Operator",
      "Full geological AI",
      "Custom models",
      "On-premise deployment",
      "Dedicated account manager",
      "99.9% SLA"
    ],
    "callToAction": "Contact Sales"
  },
  {
    "skuId": "sku_sector_resources_regional_2026",
    "businessId": "resources",
    "sourceBusinessId": "resources",
    "businessName": "Anchor Resources",
    "name": "Regional",
    "unitAmountMinor": 299000,
    "billingInterval": "month",
    "features": [
      "5 users",
      "Resource mapping",
      "Basic monitoring",
      "Compliance alerts",
      "Email support"
    ],
    "callToAction": "Request demo"
  },
  {
    "skuId": "sku_sector_resources_authority_2026",
    "businessId": "resources",
    "sourceBusinessId": "resources",
    "businessName": "Anchor Resources",
    "name": "Authority",
    "unitAmountMinor": 999000,
    "billingInterval": "month",
    "features": [
      "25 users",
      "Everything in Regional",
      "Water intelligence",
      "Forest monitoring",
      "API access",
      "Priority support"
    ],
    "callToAction": "Request demo"
  },
  {
    "skuId": "sku_sector_resources_sovereign_2026",
    "businessId": "resources",
    "sourceBusinessId": "resources",
    "businessName": "Anchor Resources",
    "name": "Sovereign",
    "unitAmountMinor": 2999000,
    "billingInterval": "month",
    "features": [
      "Unlimited users",
      "Everything in Authority",
      "Full AI models",
      "Heritage protection",
      "Government deployment",
      "Dedicated account manager",
      "99.9% SLA"
    ],
    "callToAction": "Contact Sales"
  },
  {
    "skuId": "sku_sector_retail_store_2026",
    "businessId": "retail",
    "sourceBusinessId": "retail",
    "businessName": "Anchor Retail",
    "name": "Store",
    "unitAmountMinor": 299000,
    "billingInterval": "month",
    "features": [
      "5 users",
      "Demand forecasting",
      "Basic loss prevention",
      "Sales dashboards",
      "Email support"
    ],
    "callToAction": "Request demo"
  },
  {
    "skuId": "sku_sector_retail_chain_2026",
    "businessId": "retail",
    "sourceBusinessId": "retail",
    "businessName": "Anchor Retail",
    "name": "Chain",
    "unitAmountMinor": 1299000,
    "billingInterval": "month",
    "features": [
      "50 users",
      "Everything in Store",
      "Inventory optimisation",
      "Customer intelligence",
      "API access",
      "Priority support"
    ],
    "callToAction": "Request demo"
  },
  {
    "skuId": "sku_sector_retail_enterprise_2026",
    "businessId": "retail",
    "sourceBusinessId": "retail",
    "businessName": "Anchor Retail",
    "name": "Enterprise",
    "unitAmountMinor": 3999000,
    "billingInterval": "month",
    "features": [
      "Unlimited users",
      "Everything in Chain",
      "Price optimisation",
      "Custom AI models",
      "On-premise deployment",
      "Dedicated account manager",
      "99.9% SLA"
    ],
    "callToAction": "Contact Sales"
  },
  {
    "skuId": "sku_sector_sports_club_2026",
    "businessId": "sports",
    "sourceBusinessId": "sports",
    "businessName": "Anchor Sports",
    "name": "Club",
    "unitAmountMinor": 399000,
    "billingInterval": "month",
    "features": [
      "10 users",
      "Performance analytics",
      "Match analysis",
      "Basic dashboards",
      "Email support"
    ],
    "callToAction": "Request demo"
  },
  {
    "skuId": "sku_sector_sports_federation_2026",
    "businessId": "sports",
    "sourceBusinessId": "sports",
    "businessName": "Anchor Sports",
    "name": "Federation",
    "unitAmountMinor": 1499000,
    "billingInterval": "month",
    "features": [
      "50 users",
      "Everything in Club",
      "Integrity monitoring",
      "Anti-doping intel",
      "API access",
      "Priority support"
    ],
    "callToAction": "Request demo"
  },
  {
    "skuId": "sku_sector_sports_sovereign_2026",
    "businessId": "sports",
    "sourceBusinessId": "sports",
    "businessName": "Anchor Sports",
    "name": "Sovereign",
    "unitAmountMinor": 4999000,
    "billingInterval": "month",
    "features": [
      "Unlimited users",
      "Everything in Federation",
      "Full integrity suite",
      "Custom AI models",
      "Government deployment",
      "Dedicated account manager",
      "99.9% SLA"
    ],
    "callToAction": "Contact Sales"
  },
  {
    "skuId": "sku_sector_automotive_investigator_2026",
    "businessId": "automotive",
    "sourceBusinessId": "automotive",
    "businessName": "Anchor Automotive",
    "name": "Investigator",
    "unitAmountMinor": 299000,
    "billingInterval": "month",
    "features": [
      "5 users",
      "VIN checking",
      "Stolen vehicle alerts",
      "Basic dashboards",
      "Email support"
    ],
    "callToAction": "Request demo"
  },
  {
    "skuId": "sku_sector_automotive_agency_2026",
    "businessId": "automotive",
    "sourceBusinessId": "automotive",
    "businessName": "Anchor Automotive",
    "name": "Agency",
    "unitAmountMinor": 999000,
    "billingInterval": "month",
    "features": [
      "25 users",
      "Everything in Investigator",
      "ANPR intelligence",
      "Port monitoring",
      "API access",
      "Priority support"
    ],
    "callToAction": "Request demo"
  },
  {
    "skuId": "sku_sector_automotive_sovereign_2026",
    "businessId": "automotive",
    "sourceBusinessId": "automotive",
    "businessName": "Anchor Automotive",
    "name": "Sovereign",
    "unitAmountMinor": 2999000,
    "billingInterval": "month",
    "features": [
      "Unlimited users",
      "Everything in Agency",
      "Full AI platform",
      "Custom models",
      "Government deployment",
      "Dedicated account manager",
      "99.9% SLA"
    ],
    "callToAction": "Contact Sales"
  },
  {
    "skuId": "sku_sector_insurance_broker_2026",
    "businessId": "insurance",
    "sourceBusinessId": "insurance",
    "businessName": "Anchor Insurance",
    "name": "Broker",
    "unitAmountMinor": 399000,
    "billingInterval": "month",
    "features": [
      "5 users",
      "Risk scoring",
      "Claims monitoring",
      "Basic dashboards",
      "Email support"
    ],
    "callToAction": "Request demo"
  },
  {
    "skuId": "sku_sector_insurance_insurer_2026",
    "businessId": "insurance",
    "sourceBusinessId": "insurance",
    "businessName": "Anchor Insurance",
    "name": "Insurer",
    "unitAmountMinor": 1499000,
    "billingInterval": "month",
    "features": [
      "50 users",
      "Everything in Broker",
      "Fraud detection",
      "Cat modelling",
      "API access",
      "Priority support"
    ],
    "callToAction": "Request demo"
  },
  {
    "skuId": "sku_sector_insurance_enterprise_2026",
    "businessId": "insurance",
    "sourceBusinessId": "insurance",
    "businessName": "Anchor Insurance",
    "name": "Enterprise",
    "unitAmountMinor": 4999000,
    "billingInterval": "month",
    "features": [
      "Unlimited users",
      "Everything in Insurer",
      "Dynamic pricing engine",
      "Custom AI models",
      "On-premise deployment",
      "Dedicated account manager",
      "99.9% SLA"
    ],
    "callToAction": "Contact Sales"
  },
  {
    "skuId": "sku_sector_logistics_forwarder_2026",
    "businessId": "logistics",
    "sourceBusinessId": "logistics",
    "businessName": "Anchor Logistics",
    "name": "Forwarder",
    "unitAmountMinor": 399000,
    "billingInterval": "month",
    "features": [
      "5 users",
      "Container tracking",
      "Route planning",
      "Basic dashboards",
      "Email support"
    ],
    "callToAction": "Request demo"
  },
  {
    "skuId": "sku_sector_logistics_enterprise_2026",
    "businessId": "logistics",
    "sourceBusinessId": "logistics",
    "businessName": "Anchor Logistics",
    "name": "Enterprise",
    "unitAmountMinor": 1499000,
    "billingInterval": "month",
    "features": [
      "50 users",
      "Everything in Forwarder",
      "Disruption prediction",
      "Theft detection",
      "API access",
      "Priority support"
    ],
    "callToAction": "Request demo"
  },
  {
    "skuId": "sku_sector_logistics_global_2026",
    "businessId": "logistics",
    "sourceBusinessId": "logistics",
    "businessName": "Anchor Logistics",
    "name": "Global",
    "unitAmountMinor": 3999000,
    "billingInterval": "month",
    "features": [
      "Unlimited users",
      "Everything in Enterprise",
      "Custom AI models",
      "Smart customs",
      "On-premise deployment",
      "Dedicated account manager",
      "99.9% SLA"
    ],
    "callToAction": "Contact Sales"
  },
  {
    "skuId": "sku_sector_smartcity_district_2026",
    "businessId": "smartcity",
    "sourceBusinessId": "smartcity",
    "businessName": "Anchor Smart City",
    "name": "District",
    "unitAmountMinor": 499000,
    "billingInterval": "month",
    "features": [
      "10 users",
      "Traffic monitoring",
      "Basic analytics",
      "Compliance dashboards",
      "Email support"
    ],
    "callToAction": "Request demo"
  },
  {
    "skuId": "sku_sector_smartcity_city_2026",
    "businessId": "smartcity",
    "sourceBusinessId": "smartcity",
    "businessName": "Anchor Smart City",
    "name": "City",
    "unitAmountMinor": 1999000,
    "billingInterval": "month",
    "features": [
      "50 users",
      "Everything in District",
      "Safety intelligence",
      "Grid monitoring",
      "API access",
      "Priority support"
    ],
    "callToAction": "Request demo"
  },
  {
    "skuId": "sku_sector_smartcity_metropolitan_2026",
    "businessId": "smartcity",
    "sourceBusinessId": "smartcity",
    "businessName": "Anchor Smart City",
    "name": "Metropolitan",
    "unitAmountMinor": 5999000,
    "billingInterval": "month",
    "features": [
      "Unlimited users",
      "Everything in City",
      "Full AI platform",
      "Custom models",
      "Government deployment",
      "Dedicated account manager",
      "99.9% SLA"
    ],
    "callToAction": "Contact Sales"
  },
  {
    "skuId": "sku_sector_social_analyst_2026",
    "businessId": "social",
    "sourceBusinessId": "social",
    "businessName": "Anchor Social",
    "name": "Analyst",
    "unitAmountMinor": 399000,
    "billingInterval": "month",
    "features": [
      "5 users",
      "Platform monitoring",
      "Bot detection",
      "Basic dashboards",
      "Email support"
    ],
    "callToAction": "Request demo"
  },
  {
    "skuId": "sku_sector_social_agency_2026",
    "businessId": "social",
    "sourceBusinessId": "social",
    "businessName": "Anchor Social",
    "name": "Agency",
    "unitAmountMinor": 1499000,
    "billingInterval": "month",
    "features": [
      "25 users",
      "Everything in Analyst",
      "Influence mapping",
      "Deepfake detection",
      "API access",
      "Priority support"
    ],
    "callToAction": "Request demo"
  },
  {
    "skuId": "sku_sector_social_sovereign_2026",
    "businessId": "social",
    "sourceBusinessId": "social",
    "businessName": "Anchor Social",
    "name": "Sovereign",
    "unitAmountMinor": 4999000,
    "billingInterval": "month",
    "features": [
      "Unlimited users",
      "Everything in Agency",
      "Election integrity",
      "Custom AI models",
      "Government deployment",
      "Dedicated account manager",
      "99.9% SLA"
    ],
    "callToAction": "Contact Sales"
  },
  {
    "skuId": "sku_sector_agroshield_facility_2026",
    "businessId": "agroshield",
    "sourceBusinessId": "agroshield",
    "businessName": "Anchor AgroShield",
    "name": "Facility",
    "unitAmountMinor": 499000,
    "billingInterval": "month",
    "features": [
      "1 facility",
      "Supply chain tracking",
      "Compliance engine",
      "Basic AI",
      "Email support"
    ],
    "callToAction": "Request demo"
  },
  {
    "skuId": "sku_sector_agroshield_enterprise_2026",
    "businessId": "agroshield",
    "sourceBusinessId": "agroshield",
    "businessName": "Anchor AgroShield",
    "name": "Enterprise",
    "unitAmountMinor": 1499000,
    "billingInterval": "month",
    "features": [
      "Unlimited facilities",
      "Full diversion AI",
      "Custom compliance",
      "API access",
      "Priority support"
    ],
    "callToAction": "Contact Sales"
  },
  {
    "skuId": "sku_sector_agroshield_government_2026",
    "businessId": "agroshield",
    "sourceBusinessId": "agroshield",
    "businessName": "Anchor AgroShield",
    "name": "Government",
    "unitAmountMinor": null,
    "billingInterval": "month",
    "features": [
      "National deployment",
      "Cross-agency intel",
      "Sovereign hosting",
      "Dedicated team",
      "24/7 support"
    ],
    "callToAction": "Contact Government Sales"
  },
  {
    "skuId": "sku_sector_bioagri_farm_2026",
    "businessId": "bioagri",
    "sourceBusinessId": "bioagri",
    "businessName": "Anchor BioAgri",
    "name": "Farm",
    "unitAmountMinor": 299000,
    "billingInterval": "month",
    "features": [
      "1 farm operation",
      "Biosecurity alerts",
      "Basic pathogen intel",
      "Email support"
    ],
    "callToAction": "Request demo"
  },
  {
    "skuId": "sku_sector_bioagri_enterprise_2026",
    "businessId": "bioagri",
    "sourceBusinessId": "bioagri",
    "businessName": "Anchor BioAgri",
    "name": "Enterprise",
    "unitAmountMinor": 999000,
    "billingInterval": "month",
    "features": [
      "Unlimited farms",
      "Full pathogen AI",
      "Processing facilities",
      "API access",
      "Priority support"
    ],
    "callToAction": "Contact Sales"
  },
  {
    "skuId": "sku_sector_bioagri_government_2026",
    "businessId": "bioagri",
    "sourceBusinessId": "bioagri",
    "businessName": "Anchor BioAgri",
    "name": "Government",
    "unitAmountMinor": null,
    "billingInterval": "month",
    "features": [
      "National biosecurity",
      "Cross-agency intel",
      "Sovereign hosting",
      "Dedicated team"
    ],
    "callToAction": "Contact Government Sales"
  },
  {
    "skuId": "sku_sector_water_utility_water_utilities_2026",
    "businessId": "water",
    "sourceBusinessId": "water-utilities",
    "businessName": "Anchor Water",
    "name": "Utility",
    "unitAmountMinor": 999000,
    "billingInterval": "month",
    "features": [
      "1 utility network",
      "SCADA protection",
      "Leak detection",
      "Quality monitoring"
    ],
    "callToAction": "Request demo"
  },
  {
    "skuId": "sku_sector_water_enterprise_2026",
    "businessId": "water",
    "sourceBusinessId": "water-utilities",
    "businessName": "Anchor Water",
    "name": "Enterprise",
    "unitAmountMinor": 2499000,
    "billingInterval": "month",
    "features": [
      "Multi-network",
      "Full AI suite",
      "Predictive maintenance",
      "API access"
    ],
    "callToAction": "Contact Sales"
  },
  {
    "skuId": "sku_sector_water_government_2026",
    "businessId": "water",
    "sourceBusinessId": "water-utilities",
    "businessName": "Anchor Water",
    "name": "Government",
    "unitAmountMinor": null,
    "billingInterval": "month",
    "features": [
      "National water grid",
      "Cross-agency intel",
      "Sovereign hosting",
      "Dedicated team"
    ],
    "callToAction": "Contact Government Sales"
  },
  {
    "skuId": "sku_sector_blackflight_agency_2026",
    "businessId": "blackflight",
    "sourceBusinessId": "blackflight",
    "businessName": "Anchor Blackflight",
    "name": "Agency",
    "unitAmountMinor": 1999000,
    "billingInterval": "month",
    "features": [
      "Regional coverage",
      "Flight tracking AI",
      "Network mapping",
      "Priority support"
    ],
    "callToAction": "Apply for Access"
  },
  {
    "skuId": "sku_sector_blackflight_national_2026",
    "businessId": "blackflight",
    "sourceBusinessId": "blackflight",
    "businessName": "Anchor Blackflight",
    "name": "National",
    "unitAmountMinor": null,
    "billingInterval": "month",
    "features": [
      "National deployment",
      "Full AI suite",
      "Cross-agency fusion",
      "Sovereign hosting"
    ],
    "callToAction": "Contact Government Sales"
  },
  {
    "skuId": "sku_sector_sovereign-surveillance_national_2026",
    "businessId": "sovereign-surveillance",
    "sourceBusinessId": "sovereign-surveillance",
    "businessName": "Anchor Surveillance",
    "name": "National",
    "unitAmountMinor": null,
    "billingInterval": "month",
    "features": [
      "National deployment",
      "Full SIGINT suite",
      "Cyber + financial",
      "Sovereign hosting",
      "Dedicated team"
    ],
    "callToAction": "Contact Government Sales"
  },
  {
    "skuId": "sku_sector_humankind_ngo_2026",
    "businessId": "humankind",
    "sourceBusinessId": "humankind",
    "businessName": "Anchor HumanKind",
    "name": "NGO",
    "unitAmountMinor": 199000,
    "billingInterval": "month",
    "features": [
      "Regional coverage",
      "Disaster warnings",
      "Health alerts",
      "Basic analytics"
    ],
    "callToAction": "Request demo"
  },
  {
    "skuId": "sku_sector_humankind_government_2026",
    "businessId": "humankind",
    "sourceBusinessId": "humankind",
    "businessName": "Anchor HumanKind",
    "name": "Government",
    "unitAmountMinor": null,
    "billingInterval": "month",
    "features": [
      "National deployment",
      "Full AI suite",
      "Cross-sector intel",
      "Sovereign hosting"
    ],
    "callToAction": "Contact Government Sales"
  },
  {
    "skuId": "sku_sector_semiconductor_facility_2026",
    "businessId": "semiconductor",
    "sourceBusinessId": "semiconductor",
    "businessName": "Anchor Semiconductor",
    "name": "Facility",
    "unitAmountMinor": 1499000,
    "billingInterval": "month",
    "features": [
      "1 fab facility",
      "Chip provenance",
      "IP protection",
      "Supply chain monitoring"
    ],
    "callToAction": "Request demo"
  },
  {
    "skuId": "sku_sector_semiconductor_enterprise_2026",
    "businessId": "semiconductor",
    "sourceBusinessId": "semiconductor",
    "businessName": "Anchor Semiconductor",
    "name": "Enterprise",
    "unitAmountMinor": 4999000,
    "billingInterval": "month",
    "features": [
      "Multi-fab",
      "Full AI suite",
      "Counter-espionage",
      "API access",
      "Dedicated support"
    ],
    "callToAction": "Contact Sales"
  },
  {
    "skuId": "sku_sector_semiconductor_national_2026",
    "businessId": "semiconductor",
    "sourceBusinessId": "semiconductor",
    "businessName": "Anchor Semiconductor",
    "name": "National",
    "unitAmountMinor": null,
    "billingInterval": "month",
    "features": [
      "National semiconductor strategy",
      "Full sovereign deployment",
      "Cross-agency intel"
    ],
    "callToAction": "Contact Government Sales"
  },
  {
    "skuId": "sku_sector_quantum_enterprise_2026",
    "businessId": "quantum",
    "sourceBusinessId": "quantum",
    "businessName": "Anchor Quantum",
    "name": "Enterprise",
    "unitAmountMinor": 1999000,
    "billingInterval": "month",
    "features": [
      "PQC migration",
      "Algorithm assessment",
      "Threat forecasting",
      "API access"
    ],
    "callToAction": "Request demo"
  },
  {
    "skuId": "sku_sector_quantum_government_2026",
    "businessId": "quantum",
    "sourceBusinessId": "quantum",
    "businessName": "Anchor Quantum",
    "name": "Government",
    "unitAmountMinor": null,
    "billingInterval": "month",
    "features": [
      "National PQC strategy",
      "QKD channels",
      "Sovereign hosting",
      "Dedicated team"
    ],
    "callToAction": "Contact Government Sales"
  },
  {
    "skuId": "sku_sector_fuel_enterprise_2026",
    "businessId": "fuel",
    "sourceBusinessId": "fuel",
    "businessName": "Anchor Fuel",
    "name": "Enterprise",
    "unitAmountMinor": null,
    "billingInterval": "month",
    "features": [
      "Pipeline SCADA defence",
      "Refinery OT monitoring",
      "Price manipulation alerts",
      "API access",
      "24/7 support"
    ],
    "callToAction": "Contact Sales"
  },
  {
    "skuId": "sku_sector_fuel_government_2026",
    "businessId": "fuel",
    "sourceBusinessId": "fuel",
    "businessName": "Anchor Fuel",
    "name": "Government",
    "unitAmountMinor": null,
    "billingInterval": "month",
    "features": [
      "National fuel-reserve monitoring",
      "SPR cyber defence",
      "Sovereign hosting",
      "Dedicated team",
      "Air-gapped options"
    ],
    "callToAction": "Contact Government Sales"
  },
  {
    "skuId": "sku_sector_kinetic_defence_2026",
    "businessId": "kinetic",
    "sourceBusinessId": "kinetic",
    "businessName": "Anchor Kinetic",
    "name": "Defence",
    "unitAmountMinor": null,
    "billingInterval": "month",
    "features": [
      "Full effector management",
      "PID firewall",
      "Immutable audit",
      "OEM integration",
      "Dedicated support"
    ],
    "callToAction": "Contact Defence Sales"
  },
  {
    "skuId": "sku_sector_kinetic_government_2026",
    "businessId": "kinetic",
    "sourceBusinessId": "kinetic",
    "businessName": "Anchor Kinetic",
    "name": "Government",
    "unitAmountMinor": null,
    "billingInterval": "month",
    "features": [
      "National defence integration",
      "Sovereign hosting",
      "Air-gapped deployment",
      "ITAR/EAR compliant"
    ],
    "callToAction": "Contact Government Sales"
  },
  {
    "skuId": "sku_sector_agri_farm_2026",
    "businessId": "agri",
    "sourceBusinessId": "agri",
    "businessName": "Anchor Agri",
    "name": "Farm",
    "unitAmountMinor": 199000,
    "billingInterval": "month",
    "features": [
      "1 operation",
      "Field monitoring",
      "Pest alerts",
      "Basic supply chain",
      "Email support"
    ],
    "callToAction": "Request demo"
  },
  {
    "skuId": "sku_sector_agri_cooperative_2026",
    "businessId": "agri",
    "sourceBusinessId": "agri",
    "businessName": "Anchor Agri",
    "name": "Cooperative",
    "unitAmountMinor": 799000,
    "billingInterval": "month",
    "features": [
      "10 operations",
      "Everything in Farm",
      "Commodity intelligence",
      "Cross-sector integration",
      "API access",
      "Priority support"
    ],
    "callToAction": "Request demo"
  },
  {
    "skuId": "sku_sector_agri_enterprise_2026",
    "businessId": "agri",
    "sourceBusinessId": "agri",
    "businessName": "Anchor Agri",
    "name": "Enterprise",
    "unitAmountMinor": 2999000,
    "billingInterval": "month",
    "features": [
      "Unlimited operations",
      "Everything in Cooperative",
      "Custom AI models",
      "Government integration",
      "On-premise deployment",
      "Dedicated support"
    ],
    "callToAction": "Contact sales"
  },
  {
    "skuId": "sku_sector_biotech_lab_2026",
    "businessId": "biotech",
    "sourceBusinessId": "biotech",
    "businessName": "Anchor Biotech",
    "name": "Lab",
    "unitAmountMinor": 499000,
    "billingInterval": "month",
    "features": [
      "Lab monitoring",
      "Data defence",
      "Secure auth",
      "Email support"
    ],
    "callToAction": "Request demo"
  },
  {
    "skuId": "sku_sector_biotech_biotech_enterprise_2026",
    "businessId": "biotech",
    "sourceBusinessId": "biotech",
    "businessName": "Anchor Biotech",
    "name": "Biotech Enterprise",
    "unitAmountMinor": 1599000,
    "billingInterval": "month",
    "features": [
      "Clinical program coverage",
      "Biotech threat intel",
      "Priority support",
      "API access"
    ],
    "callToAction": "Request demo"
  },
  {
    "skuId": "sku_sector_infrastructure_operator_2026",
    "businessId": "infrastructure",
    "sourceBusinessId": "infrastructure",
    "businessName": "Anchor Infrastructure",
    "name": "Operator",
    "unitAmountMinor": 599000,
    "billingInterval": "month",
    "features": [
      "Asset monitoring",
      "Operational views",
      "Secure access",
      "Email support"
    ],
    "callToAction": "Request demo"
  },
  {
    "skuId": "sku_sector_infrastructure_national_infrastructure_2026",
    "businessId": "infrastructure",
    "sourceBusinessId": "infrastructure",
    "businessName": "Anchor Infrastructure",
    "name": "National Infrastructure",
    "unitAmountMinor": 1999000,
    "billingInterval": "month",
    "features": [
      "Multi-network resilience",
      "Cyber-physical threat intel",
      "Priority support",
      "API access"
    ],
    "callToAction": "Request demo"
  },
  {
    "skuId": "sku_sector_telecom_enterprise_2026",
    "businessId": "telecom",
    "sourceBusinessId": "telecom",
    "businessName": "Anchor Telecom",
    "name": "Enterprise",
    "unitAmountMinor": 1299000,
    "billingInterval": "month",
    "features": [
      "Tower monitoring",
      "SIM fraud prevention",
      "Spectrum alerts",
      "API access",
      "24/7 support"
    ],
    "callToAction": "Request demo"
  },
  {
    "skuId": "sku_sector_telecom_government_2026",
    "businessId": "telecom",
    "sourceBusinessId": "telecom",
    "businessName": "Anchor Telecom",
    "name": "Government",
    "unitAmountMinor": null,
    "billingInterval": "month",
    "features": [
      "National telecom defence",
      "Emergency comms protection",
      "Sovereign hosting",
      "Air-gapped options"
    ],
    "callToAction": "Contact Government Sales"
  },
  {
    "skuId": "sku_sector_water_utility_water_2026",
    "businessId": "water",
    "sourceBusinessId": "water",
    "businessName": "Anchor Water Intelligence",
    "name": "Utility",
    "unitAmountMinor": 399000,
    "billingInterval": "month",
    "features": [
      "Water quality dashboards",
      "Alerting",
      "Secure access",
      "Email support"
    ],
    "callToAction": "Request demo"
  },
  {
    "skuId": "sku_sector_water_regional_authority_2026",
    "businessId": "water",
    "sourceBusinessId": "water",
    "businessName": "Anchor Water Intelligence",
    "name": "Regional Authority",
    "unitAmountMinor": 1299000,
    "billingInterval": "month",
    "features": [
      "Multi-site intelligence",
      "SCADA defence",
      "Flood resilience views",
      "Priority support"
    ],
    "callToAction": "Request demo"
  }
] as const;

export const GENERATED_PREMIUM_ADDONS = [
  {
    "skuId": "sku_addon_autonomous_soc_2026",
    "addonId": "autonomous-soc",
    "name": "Autonomous SOC",
    "description": "AI-powered Security Operations Centre that triages, investigates, and responds to threats 24/7 without human intervention.",
    "monthlyAmountMinor": 1500000,
    "yearlyAmountMinor": 14400000,
    "category": "world-first",
    "minimumTier": "business",
    "features": [
      "24/7 automated triage",
      "AI incident response",
      "Auto-escalation workflows",
      "SOAR integration",
      "Playbook engine"
    ]
  },
  {
    "skuId": "sku_addon_digital_twin_security_2026",
    "addonId": "digital-twin-security",
    "name": "Digital Twin Security",
    "description": "Create a virtual replica of your infrastructure to simulate attacks and test defences without risk to production.",
    "monthlyAmountMinor": 1200000,
    "yearlyAmountMinor": 11520000,
    "category": "world-first",
    "minimumTier": "business",
    "features": [
      "Infrastructure mirroring",
      "Attack simulation sandbox",
      "What-if scenario testing",
      "Drift comparison",
      "Continuous validation"
    ]
  },
  {
    "skuId": "sku_addon_deception_technology_2026",
    "addonId": "deception-technology",
    "name": "Deception Technology",
    "description": "Deploy honeypots, honeytokens, and decoy systems to detect and trap attackers before they reach real assets.",
    "monthlyAmountMinor": 800000,
    "yearlyAmountMinor": 7680000,
    "category": "world-first",
    "minimumTier": "team",
    "features": [
      "Automated honeypot deployment",
      "Honeytoken generation",
      "Decoy credential tracking",
      "Attacker profiling",
      "Real-time alerts"
    ]
  },
  {
    "skuId": "sku_addon_forensics_lab_2026",
    "addonId": "forensics-lab",
    "name": "Forensics Lab",
    "description": "Full digital forensics investigation suite with evidence chain-of-custody, memory analysis, and court-ready reporting.",
    "monthlyAmountMinor": 1000000,
    "yearlyAmountMinor": 9600000,
    "category": "world-first",
    "minimumTier": "business",
    "features": [
      "Memory forensics",
      "Disk image analysis",
      "Network packet forensics",
      "Chain of custody",
      "Court-ready reports"
    ]
  },
  {
    "skuId": "sku_addon_supply_chain_ai_2026",
    "addonId": "supply-chain-ai",
    "name": "Supply Chain AI",
    "description": "AI-driven analysis of your entire software supply chain — every dependency, every contributor, every risk scored in real-time.",
    "monthlyAmountMinor": 750000,
    "yearlyAmountMinor": 7200000,
    "category": "world-first",
    "minimumTier": "team",
    "features": [
      "Dependency risk scoring",
      "Contributor trust analysis",
      "Build provenance tracking",
      "SBOM generation",
      "Typosquat detection"
    ]
  },
  {
    "skuId": "sku_addon_quantum_cryptography_2026",
    "addonId": "quantum-cryptography",
    "name": "Quantum Cryptography Manager",
    "description": "Post-quantum cryptographic readiness — audit, migrate, and manage quantum-safe encryption across your stack.",
    "monthlyAmountMinor": 2000000,
    "yearlyAmountMinor": 19200000,
    "category": "world-first",
    "minimumTier": "enterprise",
    "features": [
      "PQC readiness audit",
      "Algorithm migration planner",
      "Key rotation automation",
      "Quantum risk scoring",
      "NIST PQC compliance"
    ]
  },
  {
    "skuId": "sku_addon_critical_infrastructure_2026",
    "addonId": "critical-infrastructure",
    "name": "Critical Infrastructure Protection",
    "description": "Purpose-built for SCADA, ICS, and OT environments — protect power grids, water systems, and industrial controls.",
    "monthlyAmountMinor": 2500000,
    "yearlyAmountMinor": 24000000,
    "category": "world-first",
    "minimumTier": "enterprise",
    "features": [
      "SCADA/ICS monitoring",
      "OT protocol analysis",
      "Industrial anomaly detection",
      "Safety system validation",
      "NERC CIP compliance"
    ]
  },
  {
    "skuId": "sku_addon_breach_simulator_2026",
    "addonId": "breach-simulator",
    "name": "Breach Simulator",
    "description": "Simulate real-world breach scenarios against your live infrastructure using MITRE ATT&CK techniques.",
    "monthlyAmountMinor": 500000,
    "yearlyAmountMinor": 4800000,
    "category": "world-first",
    "minimumTier": "pro",
    "features": [
      "MITRE ATT&CK simulation",
      "Custom attack chains",
      "Defence validation",
      "Gap analysis reports",
      "Remediation playbooks"
    ]
  },
  {
    "skuId": "sku_addon_dark_web_monitor_2026",
    "addonId": "dark-web-monitor",
    "name": "Dark Web Monitor",
    "description": "Continuous monitoring of dark web marketplaces, forums, and paste sites for your organisation's exposed credentials and data.",
    "monthlyAmountMinor": 850000,
    "yearlyAmountMinor": 8160000,
    "category": "world-first",
    "minimumTier": "team",
    "features": [
      "Credential leak detection",
      "Brand impersonation alerts",
      "Data broker monitoring",
      "Executive threat alerts",
      "Takedown assistance"
    ]
  },
  {
    "skuId": "sku_addon_cyber_insurance_2026",
    "addonId": "cyber-insurance",
    "name": "Cyber Insurance Integration",
    "description": "Reduce premiums by up to 40% with automated compliance evidence and real-time risk posture shared with insurers.",
    "monthlyAmountMinor": 300000,
    "yearlyAmountMinor": 2880000,
    "category": "world-first",
    "minimumTier": "pro",
    "features": [
      "Insurer API integration",
      "Premium optimization",
      "Claims automation",
      "Risk posture reporting",
      "Coverage gap analysis"
    ]
  },
  {
    "skuId": "sku_addon_compliance_soc2_2026",
    "addonId": "compliance-soc2",
    "name": "SOC 2 Type II Pack",
    "description": "Automated SOC 2 Type II audit preparation with continuous monitoring and evidence collection.",
    "monthlyAmountMinor": 500000,
    "yearlyAmountMinor": 5000000,
    "category": "compliance",
    "minimumTier": "team",
    "features": [
      "Automated evidence",
      "Continuous monitoring",
      "Auditor portal",
      "Gap remediation",
      "Annual renewal"
    ]
  },
  {
    "skuId": "sku_addon_compliance_hipaa_2026",
    "addonId": "compliance-hipaa",
    "name": "HIPAA Compliance Pack",
    "description": "Full HIPAA compliance suite for healthcare and health-tech organisations.",
    "monthlyAmountMinor": 750000,
    "yearlyAmountMinor": 7500000,
    "category": "compliance",
    "minimumTier": "team",
    "features": [
      "PHI data mapping",
      "Access controls audit",
      "BAA management",
      "Breach notification",
      "Training tracking"
    ]
  },
  {
    "skuId": "sku_addon_compliance_pci_2026",
    "addonId": "compliance-pci",
    "name": "PCI-DSS Pack",
    "description": "Payment card industry compliance with automated scanning and quarterly ASV reports.",
    "monthlyAmountMinor": 600000,
    "yearlyAmountMinor": 6000000,
    "category": "compliance",
    "minimumTier": "team",
    "features": [
      "ASV scanning",
      "SAQ automation",
      "Card data discovery",
      "Segmentation testing",
      "QSA portal"
    ]
  },
  {
    "skuId": "sku_addon_compliance_iso27001_2026",
    "addonId": "compliance-iso27001",
    "name": "ISO 27001 Pack",
    "description": "Information Security Management System automation and certification readiness.",
    "monthlyAmountMinor": 500000,
    "yearlyAmountMinor": 5000000,
    "category": "compliance",
    "minimumTier": "team",
    "features": [
      "ISMS automation",
      "Risk assessment",
      "Policy templates",
      "Internal audit tools",
      "Certification prep"
    ]
  },
  {
    "skuId": "sku_addon_compliance_fedramp_2026",
    "addonId": "compliance-fedramp",
    "name": "FedRAMP Pack",
    "description": "Federal risk and authorization management for US government cloud services.",
    "monthlyAmountMinor": 1500000,
    "yearlyAmountMinor": 15000000,
    "category": "compliance",
    "minimumTier": "enterprise",
    "features": [
      "800+ controls mapped",
      "POAM management",
      "3PAO coordination",
      "Continuous monitoring",
      "ConMon reporting"
    ]
  },
  {
    "skuId": "sku_addon_compliance_bundle_2026",
    "addonId": "compliance-bundle",
    "name": "All Compliance Bundle",
    "description": "Every compliance framework supported — SOC 2, HIPAA, PCI, ISO, FedRAMP, CMMC, NIST, and more.",
    "monthlyAmountMinor": 2500000,
    "yearlyAmountMinor": 25000000,
    "category": "compliance",
    "minimumTier": "business",
    "features": [
      "All 7 frameworks",
      "Unified dashboard",
      "Cross-framework mapping",
      "Priority support",
      "30% savings vs individual"
    ]
  },
  {
    "skuId": "sku_addon_feed_predictive_cve_2026",
    "addonId": "feed-predictive-cve",
    "name": "Predictive CVE Feed",
    "description": "AI-predicted Common Vulnerabilities and Exposures before public disclosure — average 14-day early warning.",
    "monthlyAmountMinor": 1000000,
    "yearlyAmountMinor": 9600000,
    "category": "threat-intel",
    "minimumTier": "business",
    "features": [
      "Pre-disclosure CVE alerts",
      "14-day avg early warning",
      "Exploit likelihood scoring",
      "Patch priority ranking",
      "API & webhook delivery"
    ]
  },
  {
    "skuId": "sku_addon_feed_zero_day_2026",
    "addonId": "feed-zero-day",
    "name": "Zero-Day Intelligence",
    "description": "Real-time zero-day exploit intelligence sourced from global honeypot networks and dark web monitoring.",
    "monthlyAmountMinor": 2500000,
    "yearlyAmountMinor": 24000000,
    "category": "threat-intel",
    "minimumTier": "enterprise",
    "features": [
      "Zero-day exploit alerts",
      "Global honeypot network",
      "Weaponization tracking",
      "Mitigation guidance",
      "IOC feeds"
    ]
  },
  {
    "skuId": "sku_addon_feed_nation_state_2026",
    "addonId": "feed-nation-state",
    "name": "Nation-State APT Feed",
    "description": "Track and defend against advanced persistent threats from state-sponsored actors — full TTP mapping by actor group.",
    "monthlyAmountMinor": 5000000,
    "yearlyAmountMinor": 48000000,
    "category": "threat-intel",
    "minimumTier": "enterprise",
    "features": [
      "APT group tracking",
      "TTP intelligence",
      "Campaign attribution",
      "Target sector alerts",
      "Geopolitical context"
    ]
  },
  {
    "skuId": "sku_addon_feed_dark_web_intel_2026",
    "addonId": "feed-dark-web-intel",
    "name": "Dark Web Intelligence Feed",
    "description": "Structured intelligence from dark web markets, forums, Telegram channels, and paste sites — delivered via API.",
    "monthlyAmountMinor": 2000000,
    "yearlyAmountMinor": 19200000,
    "category": "threat-intel",
    "minimumTier": "business",
    "features": [
      "Market monitoring",
      "Forum intelligence",
      "Paste site scraping",
      "Actor profiling",
      "Structured IOCs"
    ]
  },
  {
    "skuId": "sku_addon_feed_bundle_2026",
    "addonId": "feed-bundle",
    "name": "Full Intelligence Bundle",
    "description": "All threat intelligence feeds combined — predictive CVE, zero-day, nation-state, dark web, and industry-specific.",
    "monthlyAmountMinor": 7500000,
    "yearlyAmountMinor": 72000000,
    "category": "threat-intel",
    "minimumTier": "enterprise",
    "features": [
      "All 5 feeds",
      "Unified API",
      "Custom queries",
      "Analyst support",
      "35% savings vs individual"
    ]
  },
  {
    "skuId": "sku_addon_managed_soc_lite_2026",
    "addonId": "managed-soc-lite",
    "name": "Managed SOC Lite",
    "description": "Business-hours SOC monitoring with 4-hour SLA — perfect for growing teams that need expert oversight.",
    "monthlyAmountMinor": 2500000,
    "yearlyAmountMinor": 25000000,
    "category": "managed-service",
    "minimumTier": "business",
    "features": [
      "8x5 monitoring",
      "4-hour SLA",
      "Incident triage",
      "Monthly reports",
      "Escalation support"
    ]
  },
  {
    "skuId": "sku_addon_managed_soc_standard_2026",
    "addonId": "managed-soc-standard",
    "name": "Managed SOC Standard",
    "description": "24/7 SOC monitoring with 1-hour SLA — continuous coverage for organisations that can't afford gaps.",
    "monthlyAmountMinor": 5000000,
    "yearlyAmountMinor": 50000000,
    "category": "managed-service",
    "minimumTier": "business",
    "features": [
      "24/7 monitoring",
      "1-hour SLA",
      "Incident triage & response",
      "Weekly reports",
      "Escalation + on-call"
    ]
  },
  {
    "skuId": "sku_addon_managed_soc_premium_2026",
    "addonId": "managed-soc-premium",
    "name": "Managed SOC Premium",
    "description": "24/7/365 SOC with 15-minute SLA, dedicated analysts, threat hunting, and incident response.",
    "monthlyAmountMinor": 10000000,
    "yearlyAmountMinor": 100000000,
    "category": "managed-service",
    "minimumTier": "enterprise",
    "features": [
      "24/7/365 monitoring",
      "15-min SLA",
      "Dedicated analysts",
      "Proactive hunting",
      "IR retainer included"
    ]
  },
  {
    "skuId": "sku_addon_managed_soc_elite_2026",
    "addonId": "managed-soc-elite",
    "name": "Managed SOC Elite",
    "description": "White-glove SOC service with embedded analysts, custom playbooks, and executive briefings.",
    "monthlyAmountMinor": 20000000,
    "yearlyAmountMinor": 200000000,
    "category": "managed-service",
    "minimumTier": "enterprise",
    "features": [
      "Embedded analyst team",
      "Custom playbooks",
      "Board-level reporting",
      "Red team exercises",
      "Crisis management"
    ]
  }
] as const;
